export type Language = 'es' | 'en' | 'ca'

export const translations = {
  es: {
    // Navegación
    dashboard: 'Dashboard',
    pacientes: 'Pacientes',
    atenciones: 'Atenciones',
    tratamientos: 'Tractamentos',
    gastos: 'Gastos',
    reportes: 'Informes',
    calendario: 'Calendario',
    configuracion: 'Configuración',
    
    // Dashboard
    'total-pacientes': 'Total pacientes',
    'total-atenciones': 'Total atenciones',
    'ingresos-mes': 'Ingresos del mes',
    'gastos-mes': 'Gastos del mes',
    'acciones-rapidas': 'Acciones rápidas',
    'registrar-consulta': 'Registrar consulta',
    'añadir-cliente': 'Añadir cliente',
    'nueva-atencion': 'Nueva atención',
    'nuevo-paciente': 'Nuevo paciente',
    'resumen-financiero': 'Resumen financiero del mes',
    'ingresos-totales': 'Ingresos totales',
    'gastos-totales': 'Gastos totales',
    'beneficio-neto': 'Beneficio neto',
    'ingresos-por-mes': 'Ingresos por mes',
    'atenciones-recientes': 'Atenciones recientes',
    'pacientes-saldo-pendiente': 'Pacientes con saldo pendiente',
    'requieren-atencion': 'Requieren atención',
    'no-hay-datos': 'No hay datos disponibles',
    
    // Configuración
    'configuracion-titulo': 'Configuración',
    'configuracion-descripcion': 'Gestiona tu perfil y preferencias del sistema',
    'perfil': 'Perfil',
    'seguridad': 'Seguridad',
    'notificaciones': 'Notificaciones',
    'sistema': 'Sistema',
    'datos': 'Gestió de datos',
    'informacion-perfil': 'Informació del perfil',
    'actualiza-informacion': 'Actualiza tu informació personal',
    'configuracion-seguridad': 'Configuració de seguridad',
    'gestiona-password': 'Gestiona tu contraseña y configuraciones de seguridad',
    'configuracion-notificaciones': 'Configuración de notificaciones',
    'personaliza-notificaciones': 'Personaliza como y cuando recibir notificaciones',
    'configuracion-sistema': 'Configuración del sistema',
    'personaliza-sistema': 'Personaliza la apariencia y comportamiento del sistema',
    
    // Common
    guardar: 'Guardar',
    cancelar: 'Cancelar',
    buscar: 'Buscar',
    editar: 'Editar',
    eliminar: 'Eliminar',
    'cerrar-sesion': 'Cerrar sesión',
    'iniciar-sesion': 'Iniciar sesión',
    
    // Formularios
    nombre: 'Nombre',
    apellidos: 'Apellidos',
    email: 'Email',
    telefono: 'Teléfono',
    direccion: 'Dirección',
    
    // Sistema
    tema: 'Tema',
    idioma: 'Idioma',
    'zona-horaria': 'Zona horaria',
    'formato-fecha': 'Formato de fecha',
    moneda: 'Moneda',
    claro: 'Claro',
    oscuro: 'Oscuro',
    automatico: 'Automático',
    español: 'Español',
    ingles: 'Inglés',
    catalan: 'Catalán',
    'buscar-zona-horaria': 'Buscar zona horaria...',
    'zonas-encontradas': 'zona(es) horaria(es) encontrada(s)',
    'no-encontradas': 'No se encontraron zonas horarias',
    'idioma-region': 'Idioma y región',
    apariencia: 'Apariencia',
    'informacion-personal': 'Información personal',
    'contraseñas-acceso': 'Contraseñas y acceso',
    'alertas-comunicaciones': 'Alertas y comunicaciones',
    'preferencias-generales': 'Preferencias generales',
    'respaldos-exportacion': 'Copias de seguridad y exportación',
    'guardando': 'Guardando...',
    'guardar-configuracion': 'Guardar configuración',
    'opciones-adicionales': 'Opciones adicionales',
    'mostrar-temperatura-botox': 'Mostrar temperatura de Botox',
    'mostrar-temperatura-botox-descripcion': 'Muestra la temperatura del refrigerador de Botox en el header',
    
    // Login
    'kenzen-title': 'Kenzen 503',
    'sistema-gestion': 'Sistema de gestión de citas médicas',
    'nombre-usuario': 'Nombre de usuario',
    'ingresa-usuario': 'Ingresa tu nombre de usuario',
    'usuario-requerido': 'El nombre de usuario es obligatorio',
    'contraseña': 'Contraseña',
    'ingresa-contraseña': 'Ingresa tu contraseña',
    'contraseña-requerida': 'La contraseña es obligatoria',
    'iniciando-sesion': 'Iniciar sesión',
    'derechos-reservados': '© 2024 Tatiana Aldaz, Kenzen Facturación. Todos los derechos reservados.',
    'sistema-medica': 'Sistema de gestión médica',
    
    // Dashboard
    'atenciones-hoy': 'Atenciones hoy',
    'ingresos-hoy': 'Ingresos hoy',
    'gastos-hoy': 'Gastos hoy',
    'tratamientos-activos': 'Tratamientos activos',
    'pacientes-nuevos-hoy': 'Pacientes nuevos hoy',
    'nuevos-este-mes': 'Nuevos este mes',
    'citas-dia': 'Citas del día',
    'gestionar-servicios': 'Gestionar servicios',
    'registrar-gastos': 'Registrar gastos',
    'todas-atenciones': 'Todas las atenciones no anuladas',
    'sin-datos-ingresos': 'No hay datos de ingresos',
    'ingresos-apareceran': 'Los ingresos aparecerán cuando haya atenciones registradas',
    'sin-atenciones-recientes': 'No hay atenciones recientes',
    'atenciones-apareceran': 'Las atenciones aparecerán aquí cuando se registren',
    'pendiente': 'Pendiente',
    
    // Pacientes
    'buscar-pacientes': 'Buscar pacientes...',
    'nuevo-paciente-btn': 'Nuevo Paciente',
    'filtros': 'Filtros',
    'todos': 'Todos',
    'con-saldo': 'Con saldo',
    'sin-saldo': 'Sin saldo',
    'exportar': 'Exportar',
    'mostrando': 'Mostrando',
    'de': 'de',
    'resultados': 'resultados',
    'sin-resultados': 'No se han encontrado pacientes',
    'filtrar-por': 'Filtrar por',
    'documento': 'Documento',
    'telefono': 'Teléfono',
    'email': 'Email',
    'ver': 'Ver',
    'saldo': 'Saldo',
    'acciones': 'Acciones',
    
    // Header
    'buscar-placeholder': 'Buscar pacientes, atenciones, gastos, tratamientos...',
    'notificaciones': 'Notificaciones',
    'sin-notificaciones': 'No hay notificaciones',
    'botox': 'Botox',
    'temperatura': 'temperatura',
    
    // Pacientes - adicionales
    'añadir-paciente': 'Añadir paciente',
    'tipo-documento': 'Tipo de documento',
    'paciente-documento-telefono': 'Paciente, documento, teléfono, email, sector...',
    'cedula': 'Cédula',
    'pasaporte': 'Pasaporte',
    'dni': 'DNI',
    'ruc': 'RUC',
    'otros': 'Otros',
    'fecha-registro': 'Fecha de registro',
    'ultima-actualizacion': 'Última actualización',
    'confirmar-eliminar': '¿Estás seguro que quieres eliminar este paciente?',
    'eliminar-paciente': 'Eliminar paciente',
    'paciente-eliminado': 'Paciente eliminado correctamente',
    'error-eliminar': 'Error en eliminar el paciente',
    
    // Atencions
    'nueva-atencion-btn': 'Nueva atención',
    'fecha-desde': 'Fecha desde',
    'fecha-hasta': 'Fecha hasta',
    'fecha-hora': 'Fecha y hora',
    'paciente': 'Paciente',
    'ingresos': 'Ingresos',
    'tratamiento': 'Tratamiento',
    'total': 'Total',
    'estado-pago': 'Estado pago',
    'pagado': 'Pagado',
    'no-pagado': 'No pagado',
    'control-toxina': 'Control toxina botulínica',
    'cortesia': 'Cortesía',
    'desconocido': 'Desconocido',
    'estado-actual': 'Estado actual',
    'cambiar-estado': 'Cambiar estado',
    'mes-anterior': 'Mes anterior',
    'mes-siguiente': 'Mes siguiente',
    'dia-anterior': 'Día anterior',
    'dia-siguiente': 'Día siguiente',
    'detalles-atencion': 'Detalles de la atención',
    'no-especificado': 'No especificado',
    'sin-atenciones': 'No hay atenciones',
    
    // Tractaments
    'nuevo-tratamiento': 'Nuevo tratamiento',
    'buscar-tratamientos': 'Buscar tratamientos...',
    'mostrar-inactivos': 'Mostrar inactivos',
    'codigo': 'Código',
    'nombre': 'Nombre',
    'valor': 'Valor',
    'activo': 'Activo',
    'inactivo': 'Inactivo',
    'estado-actualizado': 'Estado del tratamiento actualizado',
    'error-actualizar': 'Error en actualizar tratamiento',
    'tratamiento-eliminado': 'Tratamiento eliminado correctamente',
    'error-eliminar-tratamiento': 'Error en eliminar tractament',
    'confirmar-eliminar-tratamiento': '¿Estás seguro que quieres eliminar este tratamiento?',
    'eliminar-tratamiento': 'Eliminar tratamiento',
    
    // Gastos
    'nuevo-gasto': 'Nuevo gasto',
    'fecha-gasto': 'Fecha de gasto',
    'descripcion': 'Descripción',
    'monto': 'Importe',
    'tipo-gasto': 'Tipo de gasto',
    'estado-gasto': 'Estado de gasto',
    'cancelado': 'Cancelado',
    'no-hay-gastos': 'No hay gastos',
    'totales-gastos': 'Totales de gastos',
    'confirmar-eliminar-gasto': '¿Estás seguro que quieres eliminar este gasto?',
    'gasto-eliminado': 'Gasto eliminado correctamente',
    'error-eliminar-gasto': 'Error en eliminar gasto',
    
    // Calendari
    'nueva-cita': 'Nueva cita',
    'sin-citas': 'No hay citas programadas',
    'lunes': 'Lunes',
    'martes': 'Martes',
    'miercoles': 'Miércoles',
    'jueves': 'Jueves',
    'viernes': 'Viernes',
    'sabado': 'Sábado',
    'domingo': 'Domingo',
    
    // Informes
    'reportes': 'Informes',
    'reporte-completo': 'Informe completo',
    'reporte-ventas': 'Informe de ventas',
    'ingresos-por-mes-grafico': 'Ingresos por mes',
    'formas-pago': 'Formas de pago',
    'tratamientos-mas-usados': 'Tratamientos más utilizados',
    'tarjeta-credito': 'Tarjeta de crédito',
    'tarjeta-debito': 'Tarjeta de débito',
    'efectivo': 'Efectivo',
    'transferencia': 'Transferencia',
    'no-hay-datos-reporte': 'No hay datos para mostrar en este período',
    'hoy': 'Hoy',
    'todos': 'Todos',
    'activas': 'Activas',
    'anuladas': 'Anuladas',
    'semana': 'Setmana',
    'dia': 'Día',
    'editar': 'Editar',
    'reporte-financiero': 'Informe financiero',
    'reporte-operativo': 'Informe operativo',
    'comparativo-anual': 'Comparativo anual',
    'analisis-tendencias': 'Análisis de tendencias',
    'analisis-rentabilidad': 'Análisis de rentabilidad',
    'hora': 'Hora',
    'generar': 'Generar',
    'desde': 'Desde',
    'hasta': 'Hasta',
    'tipo-reporte': 'Tipo de informe',
    'año-anterior': 'Año anterior',
    'año-siguiente': 'Año siguiente',
    'año-actual': 'Año actual',
    'ingresos-totales': 'Ingresos totales',
    'total-atenciones': 'Total de atenciones',
    'promedio-atencion': 'Promedio de atención',
    'ingresos-periodo': 'Ingresos del período',
    'gastos-periodo': 'Gastos del período',
    'cantidad-gastos-periodo': 'Cantidad de gastos',
    'promedio-gasto-periodo': 'Promedio por gasto',
    'pacientes-nuevos-periodo': 'Pacientes nuevos en el período',
    'pacientes-mes-en-periodo': 'Nuevos este mes (en período)',
    'pacientes-hoy-en-periodo': 'Nuevos hoy (en período)',
    'tratamientos-distintos-periodo': 'Tratamientos distintos',
    'total-usos-tratamientos': 'Total de aplicaciones',
    'tratamientos-inactivos': 'Tratamientos inactivos',
    'resumen-financiero-periodo': 'Resumen financiero del período',
    'margen-beneficio': 'Margen de beneficio',
    'atenciones-no-cobradas': 'Atenciones no cobradas',
    'pendiente-cobro': 'pendiente de cobro',
    'descuentos-aplicados': 'Descuentos aplicados',
    'atenciones-cortesia': 'Atenciones de cortesía',
    'ingresos-vs-gastos': 'Ingresos vs gastos por mes',
    'del-periodo': 'Del período',
    'estado-cobro-atenciones': 'Estado de cobro de atenciones',
    'atenciones-por-dia-semana': 'Atenciones por día de la semana',
    'atenciones-por-mes': 'Atenciones por mes',
    'pacientes-por-sector': 'Pacientes por sector',
    'sin-datos-ingresos': 'No hay datos de ingresos',
    'sin-datos-atenciones': 'No hay datos de atenciones',
    'sin-datos-financieros': 'No hay datos financieros en el período',
    'sin-datos-formas-pago': 'No hay datos de formas de pago',
    'sin-datos-estado-pago': 'No hay datos de estado de cobro',
    'top-pacientes-periodo': 'Pacientes más frecuentes del período',
    'visitas': 'Visitas',
    'total-facturado': 'Total facturado',
    'atenciones-pendientes-cobro': 'Atenciones pendientes de cobro',
    'sin-atenciones-pendientes': 'No hay atenciones pendientes de cobro',
    'pacientes-saldo-pendiente': 'Pacientes con saldo pendiente',
    'saldo-pendiente': 'Saldo pendiente',
    'sin-saldos-pendientes': 'No hay pacientes con saldo pendiente',
    'sin-datos-pacientes': 'No hay datos de pacientes en el período',
    'transacciones': 'Transacciones',
    'paciente': 'Paciente',
    'ingresos': 'Ingresos',
    'atenciones-realizadas': 'Atenciones realizadas',
    'ticket-promedio': 'Ticket promedio',
    'total-gastos': 'Total de gastos',
    'gastos-mes': 'Gastos del mes',
    'gastos-hoy': 'Gastos de hoy',
    'gastos-categoria': 'Gastos por categoría',
    'ingresos-por-mes': 'Ingresos por mes',
    
    // Encabezados de tablas
    'nro-documento': 'Nº documento',
    'tipo-documento-tabla': 'Tipo documento',
    'nombre-paciente': 'Paciente',
    'nro-identificacion': 'Nº identificación',
    'nombre-factura': 'Factura',
    'fecha-hora-tabla': 'Fecha y hora',
    'hora-tabla': 'Hora',
    'valor-tabla': 'Valor',
    'detalles-tabla': 'Detalles',
    'forma-pago': 'Forma pago',
    'todas': 'Todas',
    'cheque': 'Cheque',
    'saldo-favor': 'Saldo a favor',
    'otro-financiero': 'Otros Con Utilización Del Sistema Financiero',
    'filas-pagina': 'Filas por página',
    'ultimos-meses': 'Últimos 12 meses',
    'distribucion-actual': 'Distribución actual',
    'exportar-reporte': 'Exportar reporte',
    'exportar-pdf-completo': 'Exportar PDF completo',
    'exportar-excel': 'Exportar Excel',
    'imprimir-reporte': 'Imprimir reporte',
    'vista-previa': 'Vista previa',
    'ver-detalles': 'Ver detalles',
    'cambiar-estado-pago': 'Cambiar estado de pago',
    'nuevo-estado-pago': 'Nuevo estado de pago',
    'atencion-pagada': 'La atención ha sido pagada',
    'atencion-no-pagada': 'La atención no ha sido pagada',
    'pago-pendiente-confirmacion': 'Pago pendiente de confirmación',
    'atencion-cortesia': 'Atención de cortesia (sin costo)',
    'esta-accion-no-se-puede-deshacer': 'Esta acción no se puede deshacer',
    'sector': 'Sector',
    'nro-factura': 'Nº factura',
    'detalle': 'Detalle',
    'descuento': 'Descuento',
    'observaciones': 'Observaciones',
    'precio': 'Precio',
    'estado': 'Estado',
    'fecha': 'Fecha',
    'concepto': 'Concepto',
    'categoria': 'Categoría',
    'subcategoria': 'Subcategoria',
    'tipo': 'Tipo',
    'cargando': 'Cargando...',
    'cargando-atenciones': 'Cargando atenciones...',
    'cargando-pacientes': 'Cargando pacientes...',
    'cargando-tratamientos': 'Cargando tratamientos...',
    'resetear-año-actual': 'Restablecer año actual',
    'filtros-reporte': 'Filtros de informe',
    'configuracion': 'Configuración',
    'confirmar-eliminar': 'Confirmar eliminación',
    'eliminar': 'Eliminar',
    'atenciones-del': 'Atenciones del',
    'sin-fecha-seleccionada': 'Sin fecha seleccionada',
    'editar-paciente': 'Editar paciente',
    'nuevo-paciente': 'Nuevo paciente',
    'detalles-paciente': 'Detalles del paciente',
    'informacion-personal': 'Información personal',
    'datos-facturacion': 'Datos de facturación',
    'informacion-sistema': 'Información del sistema',
    'nombre-completo': 'Nombre completo',
    'direccion': 'Dirección',
    'no-especificado': 'No especificado',
    'no-especificada': 'No especificada',
    'cargando-datos-facturacion': 'Cargando datos de facturación...',
    'no-hay-datos-facturacion': 'No hay datos de facturación',
    'paciente-sin-perfiles-facturacion': 'Este paciente no tiene perfiles de facturación registrados',
    'principal': 'Principal',
    'registrado-el': 'Registrado el',
    'cargando-saldos': 'Cargando saldos...',
    'sin-movimientos-saldo': 'Sin movimientos de saldo',
    'paciente-sin-movimientos-saldo': 'Este paciente no tiene movimientos de saldo registrados',
    'resumen-saldo': 'Resumen de saldo',
    'saldo-total': 'Saldo Total',
    'movimientos-saldo': 'Movimientos de saldo',
    'movimientos-saldo-cargaran': 'Los movimientos de saldo se cargarán cuando sea necesario',
    'id-paciente': 'ID del paciente',
    'fecha-registro': 'Fecha de registro',
    'ultima-actualizacion': 'Última actualización',
    'eliminando': 'Eliminando...',
    'no-puede-eliminarse-a-si-mismo': 'No puedes eliminarte a ti mismo',
    'cerrar': 'Cerrar',
    'confirmar-eliminar-paciente': 'Estás seguro que quieres eliminar este paciente?',
    'informacion-paciente': 'Información del paciente',
    'importante': 'Importante',
    'no-se-puede-eliminar-paciente-atenciones': 'No es podrá eliminar el paciente si tiene atenciones registradas. En este caso, se mostrará un mensaje de error.',
    'cancelar': 'Cancelar',
    'eliminando': 'Eliminando...',
    'estado-saldo': 'Estado del saldo',
    'sin-email': 'Sin email',
    'añadir-paciente': 'Añadir paciente',
    'buscar': 'Buscar',
    'paciente-documento-telefono': 'Buscar por paciente, documento, teléfono...',
    'tipo-documento': 'Tipo de documento',
    'cedula': 'Cédula',
    'pasaporte': 'Pasaporte',
    'dni': 'DNI',
    'ruc': 'RUC',
    'otros': 'Otros',
    'a-favor': 'A favor',
    'a-deber': 'A deber',
    'sin-sector': 'Sin sector',
    'busqueda-activa': 'Búsqueda activa',
    'mostrando-todos-resultados': 'Mostrando todos los resultados por',
    'total-registrados': 'Total registrados',
    'registros': 'registros',
    'error': 'Error',
    'año': 'Año',
    'este-mes-de': 'Este mes de',
    'sin-telefono': 'Sin teléfono',
    'este-año': 'Este año',
    'este-mes': 'Este mes',
    'limpiar-busqueda': 'Limpiar búsqueda',
    'editar-atencion': 'Editar atención',
    'nueva-atencion-btn': 'Nueva atención',
    'fecha-requerida': 'La fecha es obligatoria',
    'debe-seleccionar-paciente': 'Debe seleccionar un paciente',
    'nombre-minimo-caracteres': 'El nombre debe tener al menos 2 caracteres',
    'numero-identificacion-requerido': 'El número de identificación es obligatorio',
    'email-invalido': 'Email inválido',
    'tratamiento-requerido': 'El tratamiento es obligatorio',
    'valor-mayor-cero': 'El valor debe ser mayor a 0',
    'descuento-no-negativo': 'El descuento no puede ser negativo',
    'valor-total-mayor-cero': 'El valor total debe ser mayor a 0',
    'motivo-anulacion-obligatorio': 'El motivo de anulación es obligatorio cuando se anula la atención',
    'atencion-creada-correctamente': 'Atención creada correctamente',
    'atencion-actualizada-correctamente': 'Atención actualizada correctamente',
    'error-crear-atencion': 'Error en crear la atención',
    'error-actualizar-atencion': 'Error en actualizar la atención',
    'buscar-por-nombre-documento': 'Buscar por nombre o documento...',
    'seleccionado': 'Seleccionado',
    'ningun-paciente-seleccionado': 'Ningún paciente seleccionado',
    'saldo-paciente': 'Saldo del paciente',
    'paciente-saldo-favor-utilizar': 'El paciente tiene saldo a favor que puede ser utilizado',
    'paciente-saldo-pendiente-pago': 'El pacient té saldo pendent de pagament',
    'paciente-no-saldo-pendiente': 'El paciente no tiene saldo pendiente',
    'paciente-no-movimientos-saldo': 'El paciente no tiene movimientos de saldo registrados',
    'informacion-facturacion': 'Información de facturación',
    'numero-factura': 'Número de factura',
    'seleccionar-forma-pago': 'Seleccionar forma de pago',
    'detalles-adicionales-pago': 'Detalles adicionales del pago',
    'usar-otros-datos-facturacion': 'Utilizar otros datos de facturación',
    'agregar-datos': 'Agregar datos',
    'no-hay-datos-facturacion-disponibles': 'No hay datos de facturación disponibles. Puedes agregar nuevos datos.',
    'observaciones-adicionales': 'Observaciones adicionales',
    'anular-atencion': 'Anular atención',
    'motivo': 'Motivo',
    'describe-motivo-anulacion': 'Describe el motivo de la anulación...',
    'actualizar': 'Actualizar',
    'agregar-datos-facturacion': 'Agregar datos de facturación',
    'nombre-requerido': 'El nombre es obligatorio',
    'numero-documento-requerido': 'El número de documento es obligatorio',
    'datos-facturacion-creados': 'Datos de facturación creados correctamente',
    'error-crear-datos-facturacion': 'Error en crear los datos de facturación',
    'datos-facturacion-actualizados': 'Datos de facturación actualizados correctamente',
    'error-actualizar-datos-facturacion': 'Error en actualizar los datos de facturación',
    'datos-facturacion-eliminados': 'Datos de facturación eliminados correctamente',
    'error-eliminar-datos-facturacion': 'Error en eliminar los datos de facturación',
    'movimiento-saldo-creado': 'Movimiento de saldo creado correctamente',
    'error-crear-movimiento-saldo': 'Error en crear el movimiento de saldo',
    'paciente-actualizado-correctamente': 'Paciente actualizado correctamente',
    'paciente-creado-correctamente': 'Paciente creado correctamente',
    'error-guardar-paciente': 'Error en guardar el paciente',
    'ingrese-nombre-completo': 'Ingrese el nombre completo',
    'ingrese-numero-documento': 'Ingrese el número de documento',
    'ingrese-direccion': 'Ingrese la dirección',
    'ingrese-sector': 'Ingrese el sector',
    'ingrese-email': 'Ingrese el email',
    'marcar-opcion-datos-facturacion': 'Marca esta opción si quieres agregar datos de facturación diferentes a los datos personales',
    'crear-paciente': 'Crear paciente',
    'añadir-paciente': 'Añadir paciente',
    'añadir-movimiento': 'Agregar movimiento',
    'editar-datos-facturacion': 'Editar datos de facturación',
    'añadir-datos-facturacion-modal': 'Agregar datos de facturación',
    'confirmar-eliminar-datos-facturacion': 'Estás seguro que quieres eliminar estos datos de facturación?',
    'informacion-datos': 'Información de los datos',
    'eliminar-datos': 'Eliminar datos',
    'editar-movimiento-saldo': 'Editar movimiento de saldo',
    'añadir-movimiento-saldo': 'Agregar movimiento de saldo',
    'saldos': 'Saldos',
    'añadir-datos-facturacion': 'Agregar datos de facturación',
    'añadir-gasto': 'Agregar gasto',
    'total-general': 'Total general',
    'rango-seleccionado': 'Rango seleccionado',
    'selecciona-fechas': 'Selecciona fechas',
    'buscar-gastos-placeholder': 'Descripción, proveedor, factura...',
    'todas-las-categorias': 'Todas las categorías',
    'suministros': 'Suministros',
    'equipos': 'Equipos',
    'servicios': 'Servicios',
    'personal': 'Personal',
    'mantenimiento': 'Mantenimiento',
    'todos-los-tipos': 'Todos los tipos',
    'fijo': 'Fijo',
    'variable': 'Variable',
    'ocasional': 'Ocasional',
    'todos-los-estados': 'Todos los estados',
    'vencido': 'Vencido',
    'fecha-desde-no-puede-ser-superior': 'La fecha "Desde" no puede ser superior a "Hasta"',
    'estado-gasto-actualizado': 'Estado de gasto actualizado correctamente',
    'error-actualizar-estado-gasto': 'Error en actualizar el estado de la gasto',
    'error-cargar-gastos': 'Error en cargar los gastos',
    'anterior': 'Anterior',
    'siguiente': 'Siguiente',
    'detalles-gasto': 'Detalles de la gasto',
    'gasto-anulado': 'Gasto anulado',
    'anulado': 'Anulado',
    'motivo-anulacion': 'Motivo de anulación',
    'nuevo-estado-gasto': 'Nuevo estado de gasto',
    'gasto-ha-sido-pagado': 'El gasto ha sido pagado',
    'gasto-ha-sido-cancelado': 'El gasto ha sido cancelado',
    'informacion-basica': 'Información básica',
    'tipo-gasto': 'Tipo de gasto',
    'informacion-financiera': 'Información financiera',
    'informacion-proveedor': 'Información del proveedor',
    'numero-recibo': 'Número de recibo',
    'fechas': 'Fechas',
    'fecha-gasto': 'Fecha de la gasto',
    'fecha-vencimiento': 'Fecha de vencimiento',
    'informacion-adicional': 'Información adicional',
    'archivos-adjuntos': 'Archivos adjuntos',
    // GastoForm - Validaciones y mensajes
    'concepto-minimo-caracteres': 'El concepto debe tener al menos 2 caracteres',
    'descripcion-minimo-caracteres': 'La descripción debe tener al menos 2 caracteres',
    'categoria-obligatoria': 'La categoria es obligatoria',
    'fecha-gasto-obligatoria': 'La fecha de la gasto es obligatoria',
    'gasto-creado-correctamente': 'Gasto creado correctamente',
    'gasto-actualizado-correctamente': 'Gasto actualizado correctamente',
    'error-crear-gasto': 'Error en crear la gasto',
    'error-actualizar-gasto': 'Error en actualizar la gasto',
    'id-gasto-no-disponible': 'ID de gasto no disponible para actualización',
    'concepto-gasto': 'Concepto de la gasto',
    'descripcion-gasto': 'Descripción de la gasto',
    'seleccionar-categoria': 'Seleccionar categoría',
    'seleccionar-subcategoria': 'Seleccionar subcategoría',
    'moneda': 'Moneda',
    'dolar-americano': 'Dólar Americano',
    'euro': 'Euro',
    'sol-peruano': 'Sol Peruano',
    'peso-colombiano': 'Pes Colombià',
    'peso-mexicano': 'Peso Mexicano',
    'seleccionar-forma-pago': 'Seleccionar forma de pago',
    'nombre-proveedor': 'Nombre del proveedor',
    'numero-factura': 'Número de factura',
    'numero-recibo-placeholder': 'Número de recibo',
    'observaciones-adicionales': 'Observaciones adicionales...',
    'ruta-archivo-adjunto': 'Ruta de el archivo adjunto',
    // Subcategorías
    'medicamentos': 'Medicamentos',
    'material-quirurgico': 'Material quirúrgico',
    'material-oficina': 'Material de oficina',
    'productos-limpieza': 'Productos de limpieza',
    'equipos-medicos': 'Equipos médicos',
    'equipos-oficina': 'Equipos de oficina',
    'mobiliario': 'Mobiliario',
    'tecnologia': 'Tecnología',
    'servicios-medicos': 'Servicios médicos',
    'servicios-limpieza': 'Servicios de limpieza',
    'servicios-mantenimiento': 'Servicios de mantenimiento',
    'servicios-consultoria': 'Servicios de consultoría',
    'salarios': 'Salarios',
    'beneficios': 'Beneficios',
    'capacitacion': 'Capacitación',
    'seguros': 'Seguros',
    'mantenimiento-preventivo': 'Mantenimiento preventivo',
    'reparaciones': 'Reparaciones',
    'servicios-tecnicos': 'Servicios técnicos',
    'gastos-varios': 'Gastos varios',
    'impuestos': 'Impuestos',
    // Tratamientos - Nuevas traducciones
    'añadir-tratamiento': 'Agregar tratamiento',
    'error-cargar-tratamientos': 'Error en cargar los tratamientos',
    'no-se-pudieron-cargar-tratamientos': 'No se pudieron cargar los tratamientos. Por favor, intenta nuevamente.',
    'buscar-tratamientos-placeholder': 'Nombre, código...',
    'no-se-encontraron-tratamientos': 'No se encontraron tratamientos',
    'sin-codigo': 'Sin código',
    'sin-detalles': 'Sin detalles',
    'desactivar': 'Desactivar',
    'activar': 'Activar',
    'editar-tratamiento': 'Editar tratamiento',
    'informacion-tratamiento': 'Información del tratamiento',
    'asegurate-tratamiento-no-utilizado': 'Asegúrate que el tratamiento no esté siendo utilizado en atenciones antes de eliminarlo.',
    'nombre-tratamiento-requerido': 'El nombre del tratamiento es obligatorio',
    'valor-requerido': 'El valor es obligatorio',
    'tratamiento-actualizado-exitosamente': 'Tratamiento actualizado exitosamente',
    'tratamiento-creado-exitosamente': 'Tratamiento creado exitosamente',
    'error-guardar-tratamiento': 'Error en guardar tratamiento',
    'codigo-interno': 'Código interno',
    'nombre-tratamiento-placeholder': 'Nombre del tratamiento *',
    'añadir': 'Añadir',
    // DatosFacturacionTable
    'gestiona-perfiles-facturacion': 'Gestiona los perfiles de facturación del paciente',
    'marcar-como-principal': 'Marcar como principal',
    'contacto': 'Contacto',
    // Seguridad del Sistema
    'seguridad-sistema': 'Seguridad del sistema',
    'seguridad-del-sistema': 'Seguridad del sistema',
    'configuracion-seguridad-sistema': 'Configuración de seguridad y protección del sistema',
    'sesion-activa': 'Sesión activa',
    'sesion-segura-encriptada': 'La sesión está segura y encriptada',
    'ver-detalles-seguridad': 'Ver detalles de seguridad',
    'configuracion-seguridad-actualizada': 'La configuración de seguridad se actualiza automáticamente',
    // Respaldos
    'respaldos-automaticos': 'Copias de seguridad automáticas',
    'crear-respaldos-automaticos': 'Crear copias de seguridad automáticas de los datos',
    'frecuencia': 'Frecuencia',
    'diario': 'Diario',
    'semanal': 'Semanal',
    'mensual': 'Mensual',
    'respaldos': 'Copias de seguridad',
    // Detalles de Seguridad
    'detalles-seguridad': 'Detalles de seguridad',
    'estado-conexion': 'Estado de la conexión',
    'protocolo-seguro': 'Protocolo seguro',
    'certificado-ssl': 'Certificado SSL',
    'valido': 'Válido',
    'encriptacion': 'Encriptación',
    'informacion-sesion': 'Información de sesión',
    'usuario-actual': 'Usuario actual',
    'fecha-inicio-sesion': 'Última actividad',
    'configuraciones-seguridad': 'Configuraciones de seguridad',
    'autenticacion-dos-factores': 'Autenticación de dos factores',
    'no-disponible': 'No disponible',
    'sesiones-activas': 'Sesiones activas',
    'tiempo-inactividad': 'Tiempo de inactividad',
    'minutos': 'minutos',
    'recomendaciones-seguridad': 'Recomendaciones de seguridad',
    'cambiar-contraseña-regularmente': 'Cambiar la contraseña regularmente',
    'no-compartir-credenciales': 'No compartir credenciales con nadie',
    'cerrar-sesion-dispositivos-compartidos': 'Cerrar sesión en dispositivos compartidos',
    'usar-contraseñas-fuertes': 'Utilizar contraseñas fuertes y únicas',
    'rol': 'Rol',
    // Tabla de Seguridad
    'aspecto': 'Aspecto',
    'conexion': 'Conexión',
    'estado-sesion': 'Estado de sesión',
    'informacion': 'Información',
    // Usuarios
    'usuarios': 'Usuarios',
    'gestionar-usuarios': 'Gestiona los usuarios del sistema',
    'añadir-usuario': 'Agregar usuario',
    'buscar-usuarios': 'Buscar usuarios...',
    'todos-los-roles': 'Todos los roles',
    'rol-admin': 'Administrador',
    'rol-doctor': 'Doctor',
    'rol-recepcionista': 'Recepcionista',
    'rol-contador': 'Contable',
    'rol-usuario': 'Usuario',
    'cargando-usuarios': 'Cargando usuarios',
    'no-se-encontraron-usuarios': 'No se encontraron usuarios',
    'editar-usuario': 'Editar usuario',
    'nuevo-usuario': 'Nuevo usuario',
    'detalles-usuario': 'Detalles de usuario',
    'usuario-creado-exitosamente': 'Usuario creado exitosamente',
    'error-crear-usuario': 'Error en crear usuario',
    'usuario-actualizado-exitosamente': 'Usuario actualizado exitosamente',
    'error-actualizar-usuario': 'Error en actualizar usuario',
    'usuario-eliminado': 'Usuario eliminado exitosamente',
    'error-eliminar-usuario': 'Error en eliminar usuario',
    'confirmar-eliminar-usuario': 'Estás seguro que quieres eliminar el usuario',
    'foto-perfil': 'Foto de perfil',
    'subir-imagen': 'Subir imagen',
    'email-requerido': 'El email es obligatorio',
    'contraseña-minimo-8': 'La contraseña debe tener al menos 8 caracteres',
    'dejar-vacio-para-no-cambiar': 'Dejar vacío para no cambiar',
    'nueva-contraseña': 'Nueva contraseña',
    'ingresa-nombre': 'Ingrese el nombre',
    'ingresa-apellidos': 'Ingrese los apellidos',
    'predeterminada-dashboard': 'Predeterminada (Dashboard)',
    'usuario-activo': 'Usuario activo',
    'archivo-debe-ser-imagen': 'El archivo debe ser una imagen',
    'imagen-debe-ser-menor-2mb': 'La imagen debe ser menor a 2MB',
    'imagen-cargada-correctamente': 'Imagen cargada correctamente',
    'error-cargar-imagen': 'Error en cargar la imagen',
    'error-procesar-imagen': 'Error en procesar la imagen',
    'imagen-eliminada': 'Imagen eliminada',
    'ingresa-email': 'Ingrese el email',
    'a': 'a',
  },
  en: {
    // Navigation
    dashboard: 'Dashboard',
    pacientes: 'Patients',
    atenciones: 'Appointments',
    tratamientos: 'Treatments',
    gastos: 'Expenses',
    reportes: 'Reports',
    calendario: 'Calendar',
    configuracion: 'Settings',
    
    // Dashboard
    'total-pacientes': 'Total patients',
    'total-atenciones': 'Total appointments',
    'ingresos-mes': 'Monthly income',
    'gastos-mes': 'Monthly expenses',
    'acciones-rapidas': 'Quick actions',
    'registrar-consulta': 'Register consultation',
    'añadir-cliente': 'Add client',
    'nueva-atencion': 'New appointment',
    'nuevo-paciente': 'New patient',
    'resumen-financiero': 'Monthly financial summary',
    'ingresos-totales': 'Total income',
    'gastos-totales': 'Total expenses',
    'beneficio-neto': 'Net profit',
    'ingresos-por-mes': 'Income by month',
    'atenciones-recientes': 'Recent appointments',
    'pacientes-saldo-pendiente': 'Patients with pending balance',
    'requieren-atencion': 'Require attention',
    'no-hay-datos': 'No data available',
    
    // Configuration
    'configuracion-titulo': 'Settings',
    'configuracion-descripcion': 'Manage your profile and system preferences',
    'perfil': 'Profile',
    'seguridad': 'Security',
    'notificaciones': 'Notifications',
    'sistema': 'System',
    'datos': 'Data Management',
    'informacion-perfil': 'Profile Information',
    'actualiza-informacion': 'Update your personal information',
    'configuracion-seguridad': 'Security Settings',
    'gestiona-password': 'Manage your password and security settings',
    'configuracion-notificaciones': 'Notification Settings',
    'personaliza-notificaciones': 'Customize how and when to receive notifications',
    'configuracion-sistema': 'System Settings',
    'personaliza-sistema': 'Customize system appearance and behavior',
    
    // Common
    guardar: 'Save',
    cancelar: 'Cancel',
    buscar: 'Search',
    editar: 'Edit',
    eliminar: 'Delete',
    'cerrar-sesion': 'Log out',
    'iniciar-sesion': 'Log in',
    
    // Forms
    nombre: 'First name',
    apellidos: 'Last name',
    email: 'Email',
    telefono: 'Phone',
    direccion: 'Address',
    
    // System
    tema: 'Theme',
    idioma: 'Language',
    'zona-horaria': 'Time Zone',
    'formato-fecha': 'Date Format',
    moneda: 'Currency',
    claro: 'Light',
    oscuro: 'Dark',
    automatico: 'Auto',
    español: 'Spanish',
    ingles: 'English',
    catalan: 'Catalan',
    'buscar-zona-horaria': 'Search time zone...',
    'zonas-encontradas': 'time zone(s) found',
    'no-encontradas': 'No time zones found',
    'idioma-region': 'Language and Region',
    apariencia: 'Appearance',
    'informacion-personal': 'Personal information',
    'contraseñas-acceso': 'Passwords and access',
    'alertas-comunicaciones': 'Alerts and communications',
    'preferencias-generales': 'General preferences',
    'respaldos-exportacion': 'Backups and export',
    'guardando': 'Saving...',
    'guardar-configuracion': 'Save Settings',
    
    // Login
    'kenzen-title': 'Kenzen 503',
    'sistema-gestion': 'Medical appointment management system',
    'nombre-usuario': 'Username',
    'ingresa-usuario': 'Enter your username',
    'usuario-requerido': 'Username is required',
    'contraseña': 'Password',
    'ingresa-contraseña': 'Enter your password',
    'contraseña-requerida': 'Password is required',
    'iniciando-sesion': 'Log in',
    'derechos-reservados': '© 2024 Tatiana Aldaz, Kenzen Facturación. All rights reserved.',
    'sistema-medica': 'Medical management system',
    
    // Dashboard
    'atenciones-hoy': 'Today\'s appointments',
    'ingresos-hoy': 'Today\'s income',
    'gastos-hoy': 'Today\'s expenses',
    'tratamientos-activos': 'Active treatments',
    'pacientes-nuevos-hoy': 'New patients today',
    'nuevos-este-mes': 'new this month',
    'citas-dia': 'Today\'s appointments',
    'gestionar-servicios': 'Manage services',
    'registrar-gastos': 'Register expenses',
    'todas-atenciones': 'All non-cancelled appointments',
    'sin-datos-ingresos': 'No income data',
    'ingresos-apareceran': 'Income will appear when appointments are registered',
    'sin-atenciones-recientes': 'No recent appointments',
    'atenciones-apareceran': 'Appointments will appear here when registered',
    'pendiente': 'Pending',
    
    // Pacientes
    'buscar-pacientes': 'Search patients...',
    'nuevo-paciente-btn': 'New Patient',
    'filtros': 'Filters',
    'todos': 'All',
    'con-saldo': 'With balance',
    'sin-saldo': 'No balance',
    'exportar': 'Export',
    'mostrando': 'Showing',
    'de': 'of',
    'resultados': 'results',
    'sin-resultados': 'No patients found',
    'filtrar-por': 'Filter by',
    'documento': 'Document',
    'telefono': 'Phone',
    'email': 'Email',
    'ver': 'View',
    'eliminar': 'Delete',
    'saldo': 'Balance',
    'acciones': 'Actions',
    
    // Header
    'buscar-placeholder': 'Search patients, appointments, expenses, treatments...',
    'notificaciones': 'Notifications',
    'sin-notificaciones': 'No notifications',
    'botox': 'Botox',
    'temperatura': 'temperature',
    'opciones-adicionales': 'Additional Options',
    'mostrar-temperatura-botox': 'Show Botox Temperature',
    'mostrar-temperatura-botox-descripcion': 'Shows the Botox refrigerator temperature in the header',
    
    // Pacientes - adicionales
    'añadir-paciente': 'Add patient',
    'tipo-documento': 'Document type',
    'paciente-documento-telefono': 'Patient, document, phone, email, sector...',
    'cedula': 'ID Card',
    'pasaporte': 'Passport',
    'dni': 'DNI',
    'ruc': 'RUC',
    'otros': 'Others',
    'fecha-registro': 'Registration date',
    'ultima-actualizacion': 'Last update',
    'confirmar-eliminar': 'Are you sure you want to delete this patient?',
    'eliminar-paciente': 'Delete patient',
    'paciente-eliminado': 'Patient deleted successfully',
    'error-eliminar': 'Error deleting patient',
    
    // Atenciones
    'nueva-atencion-btn': 'New Appointment',
    'fecha-desde': 'Date from',
    'fecha-hasta': 'Date to',
    'fecha-hora': 'Date and Time',
    'paciente': 'Patient',
    'tratamiento': 'Treatment',
    'total': 'Total',
    'estado-pago': 'Payment Status',
    'pagado': 'Paid',
    'no-pagado': 'Not Paid',
    'control-toxina': 'Botulinum Toxin Control',
    'cortesia': 'Courtesy',
    'desconocido': 'Unknown',
    'estado-actual': 'Current status',
    'cambiar-estado': 'Change status',
    'mes-anterior': 'Previous month',
    'mes-siguiente': 'Next month',
    'dia-anterior': 'Previous day',
    'dia-siguiente': 'Next day',
    'detalles-atencion': 'Appointment Details',
    'no-especificado': 'Not specified',
    'sin-atenciones': 'No appointments found',
    
    // Tratamientos
    'nuevo-tratamiento': 'New Treatment',
    'buscar-tratamientos': 'Search treatments...',
    'mostrar-inactivos': 'Show inactive',
    'codigo': 'Code',
    'nombre': 'Name',
    'valor': 'Value',
    'activo': 'Active',
    'inactivo': 'Inactive',
    'estado-actualizado': 'Treatment status updated',
    'error-actualizar': 'Error updating treatment',
    'tratamiento-eliminado': 'Treatment deleted successfully',
    'error-eliminar-tratamiento': 'Error deleting treatment',
    'confirmar-eliminar-tratamiento': 'Are you sure you want to delete this treatment?',
    'eliminar-tratamiento': 'Delete treatment',
    
    // Gastos
    'nuevo-gasto': 'New Expense',
    'fecha-gasto': 'Expense Date',
    'descripcion': 'Description',
    'monto': 'Amount',
    'tipo-gasto': 'Expense Type',
    'estado-gasto': 'Expense Status',
    'cancelado': 'Cancelled',
    'no-hay-gastos': 'No expenses found',
    'totales-gastos': 'Expense Totals',
    'confirmar-eliminar-gasto': 'Are you sure you want to delete this expense?',
    'gasto-eliminado': 'Expense deleted successfully',
    'error-eliminar-gasto': 'Error deleting expense',
    
    // Calendario
    'nueva-cita': 'New Appointment',
    'sin-citas': 'No scheduled appointments',
    'lunes': 'Monday',
    'martes': 'Tuesday',
    'miercoles': 'Wednesday',
    'jueves': 'Thursday',
    'viernes': 'Friday',
    'sabado': 'Saturday',
    'domingo': 'Sunday',
    
    // Reportes
    'reportes': 'Reports',
    'reporte-completo': 'Complete Report',
    'reporte-ventas': 'Sales Report',
    'ingresos-por-mes-grafico': 'Income by Month',
    'formas-pago': 'Payment Methods',
    'tratamientos-mas-usados': 'Most Used Treatments',
    'tarjeta-credito': 'Credit card',
    'tarjeta-debito': 'Debit card',
    'efectivo': 'Cash',
    'transferencia': 'Transfer',
    'no-hay-datos-reporte': 'No data available for this period',
    'hoy': 'Today',
    'todos': 'All',
    'activas': 'Active',
    'anuladas': 'Cancelled',
    'semana': 'Week',
    'dia': 'Day',
    'editar': 'Edit',
    'reporte-financiero': 'Financial Report',
    'reporte-operativo': 'Operational Report',
    'comparativo-anual': 'Annual Comparison',
    'analisis-tendencias': 'Trend Analysis',
    'analisis-rentabilidad': 'Profitability Analysis',
    'hora': 'Time',
    'generar': 'Generate',
    'desde': 'From',
    'hasta': 'To',
    'tipo-reporte': 'Report Type',
    'año-anterior': 'Previous year',
    'año-siguiente': 'Next year',
    'año-actual': 'Current Year',
    'ingresos-totales': 'Total income',
    'total-atenciones': 'Total appointments',
    'promedio-atencion': 'Average per appointment',
    'ingresos-periodo': 'Period income',
    'gastos-periodo': 'Period expenses',
    'cantidad-gastos-periodo': 'Number of expenses',
    'promedio-gasto-periodo': 'Average per expense',
    'pacientes-nuevos-periodo': 'New patients in period',
    'pacientes-mes-en-periodo': 'New this month (in period)',
    'pacientes-hoy-en-periodo': 'New today (in period)',
    'tratamientos-distintos-periodo': 'Distinct treatments',
    'total-usos-tratamientos': 'Total applications',
    'tratamientos-inactivos': 'Inactive treatments',
    'resumen-financiero-periodo': 'Period financial summary',
    'margen-beneficio': 'Profit margin',
    'atenciones-no-cobradas': 'Uncollected appointments',
    'pendiente-cobro': 'pending collection',
    'descuentos-aplicados': 'Discounts applied',
    'atenciones-cortesia': 'Courtesy appointments',
    'ingresos-vs-gastos': 'Revenue vs expenses by month',
    'del-periodo': 'In period',
    'estado-cobro-atenciones': 'Payment status of appointments',
    'atenciones-por-dia-semana': 'Appointments by day of week',
    'atenciones-por-mes': 'Appointments by month',
    'pacientes-por-sector': 'Patients by sector',
    'sin-datos-ingresos': 'No revenue data',
    'sin-datos-atenciones': 'No appointment data',
    'sin-datos-financieros': 'No financial data in period',
    'sin-datos-formas-pago': 'No payment method data',
    'sin-datos-estado-pago': 'No payment status data',
    'top-pacientes-periodo': 'Most frequent patients in period',
    'visitas': 'Visits',
    'total-facturado': 'Total billed',
    'atenciones-pendientes-cobro': 'Appointments pending payment',
    'sin-atenciones-pendientes': 'No appointments pending payment',
    'pacientes-saldo-pendiente': 'Patients with outstanding balance',
    'saldo-pendiente': 'Outstanding balance',
    'sin-saldos-pendientes': 'No patients with outstanding balance',
    'sin-datos-pacientes': 'No patient data in period',
    'transacciones': 'Transactions',
    'paciente': 'Patient',
    'ingresos': 'Revenue',
    'atenciones-realizadas': 'Appointments completed',
    'ticket-promedio': 'Average ticket',
    'total-gastos': 'Total expenses',
    'gastos-mes': 'Monthly expenses',
    'gastos-hoy': 'Today\'s expenses',
    'gastos-categoria': 'Expenses by Category',
    'ingresos-por-mes': 'Income by Month',
    
    // Table headers
    'nro-documento': 'Doc. No.',
    'tipo-documento-tabla': 'Document type',
    'nombre-paciente': 'Patient name',
    'nro-identificacion': 'ID Number',
    'nombre-factura': 'Invoice name',
    'fecha-hora-tabla': 'Date and Time',
    'hora-tabla': 'Time',
    'valor-tabla': 'Value',
    'detalles-tabla': 'Details',
    'forma-pago': 'Payment method',
    'todas': 'All',
    'cheque': 'Check',
    'saldo-favor': 'Credit Balance',
    'otro-financiero': 'Others With Financial System Usage',
    'filas-pagina': 'Rows per page',
    'ultimos-meses': 'Last 12 months',
    'distribucion-actual': 'Current distribution',
    'exportar-reporte': 'Export report',
    'exportar-pdf-completo': 'Export complete PDF',
    'exportar-excel': 'Export Excel',
    'imprimir-reporte': 'Print report',
    'vista-previa': 'Preview',
    'ver-detalles': 'View details',
    'cambiar-estado-pago': 'Change Payment Status',
    'nuevo-estado-pago': 'New payment status',
    'atencion-pagada': 'Appointment has been paid',
    'atencion-no-pagada': 'Appointment has not been paid',
    'pago-pendiente-confirmacion': 'Payment pending confirmation',
    'atencion-cortesia': 'Courtesy appointment (no cost)',
    'esta-accion-no-se-puede-deshacer': 'This action cannot be undone',
    'sector': 'Sector',
    'nro-factura': 'Invoice No.',
    'detalle': 'Detail',
    'descuento': 'Discount',
    'observaciones': 'Observations',
    'precio': 'Price',
    'estado': 'Status',
    'fecha': 'Date',
    'concepto': 'Concept',
    'categoria': 'Category',
    'subcategoria': 'Subcategory',
    'tipo': 'Type',
    'cargando': 'Loading...',
    'cargando-atenciones': 'Loading appointments...',
    'cargando-pacientes': 'Loading patients...',
    'cargando-tratamientos': 'Loading treatments...',
    'resetear-año-actual': 'Reset to current year',
    'filtros-reporte': 'Report filters',
    'configuracion': 'Settings',
    'confirmar-eliminar': 'Confirm Deletion',
    'eliminar': 'Delete',
    'atenciones-del': 'Appointments of',
    'sin-fecha-seleccionada': 'No date selected',
    'editar-paciente': 'Edit patient',
    'nuevo-paciente': 'New patient',
    'detalles-paciente': 'Patient Details',
    'informacion-personal': 'Personal Information',
    'datos-facturacion': 'Billing data',
    'informacion-sistema': 'System Information',
    'nombre-completo': 'Full Name',
    'direccion': 'Address',
    'no-especificado': 'Not specified',
    'no-especificada': 'Not specified',
    'cargando-datos-facturacion': 'Loading billing data...',
    'no-hay-datos-facturacion': 'No billing data',
    'paciente-sin-perfiles-facturacion': 'This patient has no registered billing profiles',
    'principal': 'Main',
    'registrado-el': 'Registered on',
    'cargando-saldos': 'Loading balances...',
    'sin-movimientos-saldo': 'No balance movements',
    'paciente-sin-movimientos-saldo': 'This patient has no registered balance movements',
    'resumen-saldo': 'Balance Summary',
    'saldo-total': 'Total Balance',
    'movimientos-saldo': 'Balance Movements',
    'movimientos-saldo-cargaran': 'Balance movements will load when needed',
    'id-paciente': 'Patient ID',
    'fecha-registro': 'Registration Date',
    'ultima-actualizacion': 'Last Update',
    'cerrar': 'Close',
    'confirmar-eliminar-paciente': 'Are you sure you want to delete this patient?',
    'informacion-paciente': 'Patient information',
    'importante': 'Important',
    'no-se-puede-eliminar-paciente-atenciones': 'The patient cannot be deleted if they have registered appointments. In that case, an error message will be displayed.',
    'cancelar': 'Cancel',
    'eliminando': 'Deleting...',
    'no-puede-eliminarse-a-si-mismo': 'You cannot delete yourself',
    'estado-saldo': 'Balance status',
    'sin-email': 'No email',
    'añadir-paciente': 'Add patient',
    'buscar': 'Search',
    'paciente-documento-telefono': 'Search by patient, document, phone...',
    'tipo-documento': 'Document type',
    'cedula': 'ID Card',
    'pasaporte': 'Passport',
    'dni': 'DNI',
    'ruc': 'RUC',
    'otros': 'Others',
    'a-favor': 'In favor',
    'a-deber': 'In debt',
    'sin-sector': 'No sector',
    'busqueda-activa': 'Active search',
    'mostrando-todos-resultados': 'Showing all results for',
    'total-registrados': 'Total registered',
    'registros': 'records',
    'error': 'Error',
    'año': 'Year',
    'este-mes-de': 'This month of',
    'sin-telefono': 'No phone',
    'este-año': 'this year',
    'este-mes': 'this month',
    'limpiar-busqueda': 'Clear search',
    'editar-atencion': 'Edit appointment',
    'nueva-atencion-btn': 'New appointment',
    'fecha-requerida': 'Date is required',
    'debe-seleccionar-paciente': 'You must select a patient',
    'nombre-minimo-caracteres': 'Name must be at least 2 characters',
    'numero-identificacion-requerido': 'Identification number is required',
    'email-invalido': 'Invalid email',
    'tratamiento-requerido': 'Treatment is required',
    'valor-mayor-cero': 'Value must be greater than 0',
    'descuento-no-negativo': 'Discount cannot be negative',
    'valor-total-mayor-cero': 'Total value must be greater than 0',
    'motivo-anulacion-obligatorio': 'Cancellation reason is mandatory when canceling the appointment',
    'atencion-creada-correctamente': 'Appointment created successfully',
    'atencion-actualizada-correctamente': 'Appointment updated successfully',
    'error-crear-atencion': 'Error creating appointment',
    'error-actualizar-atencion': 'Error updating appointment',
    'buscar-por-nombre-documento': 'Search by name or document...',
    'seleccionado': 'Selected',
    'ningun-paciente-seleccionado': 'No patient selected',
    'saldo-paciente': 'Patient balance',
    'paciente-saldo-favor-utilizar': 'The patient has a balance in favor that can be used',
    'paciente-saldo-pendiente-pago': 'The patient has a pending balance to pay',
    'paciente-no-saldo-pendiente': 'The patient has no pending balance',
    'paciente-no-movimientos-saldo': 'The patient has no registered balance movements',
    'informacion-facturacion': 'Billing Information',
    'numero-factura': 'Invoice number',
    'seleccionar-forma-pago': 'Select payment method',
    'detalles-adicionales-pago': 'Additional payment details',
    'usar-otros-datos-facturacion': 'Use other billing data',
    'agregar-datos': 'Add data',
    'no-hay-datos-facturacion-disponibles': 'No billing data available. You can add new data.',
    'observaciones-adicionales': 'Additional observations',
    'anular-atencion': 'Cancel appointment',
    'motivo': 'Reason',
    'describe-motivo-anulacion': 'Describe the reason for cancellation...',
    'actualizar': 'Update',
    'agregar-datos-facturacion': 'Add Billing Data',
    'nombre-requerido': 'Name is required',
    'numero-documento-requerido': 'Document number is required',
    'datos-facturacion-creados': 'Billing data created successfully',
    'error-crear-datos-facturacion': 'Error creating billing data',
    'datos-facturacion-actualizados': 'Billing data updated successfully',
    'error-actualizar-datos-facturacion': 'Error updating billing data',
    'datos-facturacion-eliminados': 'Billing data deleted successfully',
    'error-eliminar-datos-facturacion': 'Error deleting billing data',
    'movimiento-saldo-creado': 'Balance movement created successfully',
    'error-crear-movimiento-saldo': 'Error creating balance movement',
    'paciente-actualizado-correctamente': 'Patient updated successfully',
    'paciente-creado-correctamente': 'Patient created successfully',
    'error-guardar-paciente': 'Error saving patient',
    'ingrese-nombre-completo': 'Enter full name',
    'ingrese-numero-documento': 'Enter document number',
    'ingrese-direccion': 'Enter address',
    'ingrese-sector': 'Enter sector',
    'ingrese-email': 'Enter email',
    'marcar-opcion-datos-facturacion': 'Check this option if you want to add billing data different from personal data',
    'crear-paciente': 'Create Patient',
    'añadir-paciente': 'Add patient',
    'añadir-movimiento': 'Add movement',
    'editar-datos-facturacion': 'Edit billing data',
    'añadir-datos-facturacion-modal': 'Add billing data',
    'confirmar-eliminar-datos-facturacion': 'Are you sure you want to delete this billing data?',
    'informacion-datos': 'Data information',
    'eliminar-datos': 'Delete Data',
    'editar-movimiento-saldo': 'Edit balance movement',
    'añadir-movimiento-saldo': 'Add balance movement',
    'saldos': 'Balances',
    'añadir-datos-facturacion': 'Add billing data',
    // Gastos - Nuevas traducciones
    'añadir-gasto': 'Add expense',
    'total-general': 'Total General',
    'rango-seleccionado': 'Selected Range',
    'selecciona-fechas': 'Select dates',
    'buscar-gastos-placeholder': 'Description, provider, invoice...',
    'todas-las-categorias': 'All categories',
    'suministros': 'Supplies',
    'equipos': 'Equipment',
    'servicios': 'Services',
    'personal': 'Personnel',
    'mantenimiento': 'Maintenance',
    'todos-los-tipos': 'All types',
    'fijo': 'Fixed',
    'variable': 'Variable',
    'ocasional': 'Occasional',
    'todos-los-estados': 'All states',
    'vencido': 'Overdue',
    'fecha-desde-no-puede-ser-superior': 'The "From" date cannot be greater than "To"',
    'estado-gasto-actualizado': 'Expense status updated successfully',
    'error-actualizar-estado-gasto': 'Error updating expense status',
    'error-cargar-gastos': 'Error loading expenses',
    'anterior': 'Previous',
    'siguiente': 'Next',
    'detalles-gasto': 'Expense details',
    'gasto-anulado': 'Cancelled Expense',
    'anulado': 'Cancelled',
    'motivo-anulacion': 'Cancellation Reason',
    'nuevo-estado-gasto': 'New expense status',
    'gasto-ha-sido-pagado': 'The expense has been paid',
    'gasto-ha-sido-cancelado': 'The expense has been cancelled',
    'informacion-basica': 'Basic Information',
    'tipo-gasto': 'Expense Type',
    'informacion-financiera': 'Financial Information',
    'informacion-proveedor': 'Provider Information',
    'numero-recibo': 'Receipt Number',
    'fechas': 'Dates',
    'fecha-gasto': 'Expense Date',
    'fecha-vencimiento': 'Due Date',
    'informacion-adicional': 'Additional Information',
    'archivos-adjuntos': 'Attached Files',
    // GastoForm - Validaciones y mensajes
    'concepto-minimo-caracteres': 'The concept must have at least 2 characters',
    'descripcion-minimo-caracteres': 'The description must have at least 2 characters',
    'categoria-obligatoria': 'Category is required',
    'fecha-gasto-obligatoria': 'Expense date is required',
    'gasto-creado-correctamente': 'Expense created successfully',
    'gasto-actualizado-correctamente': 'Expense updated successfully',
    'error-crear-gasto': 'Error creating expense',
    'error-actualizar-gasto': 'Error updating expense',
    'id-gasto-no-disponible': 'Expense ID not available for update',
    'concepto-gasto': 'Expense concept',
    'descripcion-gasto': 'Expense description',
    'seleccionar-categoria': 'Select category',
    'seleccionar-subcategoria': 'Select subcategory',
    'moneda': 'Currency',
    'dolar-americano': 'US Dollar',
    'euro': 'Euro',
    'sol-peruano': 'Peruvian Sol',
    'peso-colombiano': 'Colombian Peso',
    'peso-mexicano': 'Mexican Peso',
    'seleccionar-forma-pago': 'Select payment method',
    'nombre-proveedor': 'Provider name',
    'numero-factura': 'Invoice number',
    'numero-recibo-placeholder': 'Receipt number',
    'observaciones-adicionales': 'Additional observations...',
    'ruta-archivo-adjunto': 'Attached file path',
    // Subcategorías
    'medicamentos': 'Medications',
    'material-quirurgico': 'Surgical material',
    'material-oficina': 'Office supplies',
    'productos-limpieza': 'Cleaning products',
    'equipos-medicos': 'Medical equipment',
    'equipos-oficina': 'Office equipment',
    'mobiliario': 'Furniture',
    'tecnologia': 'Technology',
    'servicios-medicos': 'Medical services',
    'servicios-limpieza': 'Cleaning services',
    'servicios-mantenimiento': 'Maintenance services',
    'servicios-consultoria': 'Consulting services',
    'salarios': 'Salaries',
    'beneficios': 'Benefits',
    'capacitacion': 'Training',
    'seguros': 'Insurance',
    'mantenimiento-preventivo': 'Preventive maintenance',
    'reparaciones': 'Repairs',
    'servicios-tecnicos': 'Technical services',
    'gastos-varios': 'Miscellaneous expenses',
    'impuestos': 'Taxes',
    // Tratamientos - Nuevas traducciones
    'añadir-tratamiento': 'Add treatment',
    'error-cargar-tratamientos': 'Error loading treatments',
    'no-se-pudieron-cargar-tratamientos': 'Could not load treatments. Please try again.',
    'buscar-tratamientos-placeholder': 'Name, code...',
    'no-se-encontraron-tratamientos': 'No treatments found',
    'sin-codigo': 'No code',
    'sin-detalles': 'No details',
    'activo': 'Active',
    'inactivo': 'Inactive',
    'desactivar': 'Deactivate',
    'activar': 'Activate',
    'editar-tratamiento': 'Edit treatment',
    'informacion-tratamiento': 'Treatment information',
    'asegurate-tratamiento-no-utilizado': 'Make sure this treatment is not being used in appointments before deleting it.',
    'nombre-tratamiento-requerido': 'Treatment name is required',
    'valor-requerido': 'Value is required',
    'tratamiento-actualizado-exitosamente': 'Treatment updated successfully',
    'tratamiento-creado-exitosamente': 'Treatment created successfully',
    'error-guardar-tratamiento': 'Error saving treatment',
    'codigo-interno': 'Internal code',
    'nombre-tratamiento-placeholder': 'Treatment name *',
    'añadir': 'Add',
    // DatosFacturacionTable
    'gestiona-perfiles-facturacion': 'Manage patient billing profiles',
    'marcar-como-principal': 'Mark as principal',
    'contacto': 'Contact',
    // Seguridad del Sistema
    'seguridad-sistema': 'System security',
    'seguridad-del-sistema': 'System security',
    'configuracion-seguridad-sistema': 'System security and protection settings',
    'sesion-activa': 'Active Session',
    'sesion-segura-encriptada': 'Your session is secure and encrypted',
    'ver-detalles-seguridad': 'View Security Details',
    'configuracion-seguridad-actualizada': 'Security settings are automatically updated',
    // Respaldos
    'respaldos-automaticos': 'Automatic Backups',
    'crear-respaldos-automaticos': 'Create automatic data backups',
    'frecuencia': 'Frequency',
    'diario': 'Daily',
    'semanal': 'Weekly',
    'mensual': 'Monthly',
    'respaldos': 'Backups',
    // Detalles de Seguridad
    'detalles-seguridad': 'Security Details',
    'estado-conexion': 'Connection Status',
    'protocolo-seguro': 'Secure Protocol',
    'certificado-ssl': 'SSL Certificate',
    'valido': 'Valid',
    'encriptacion': 'Encryption',
    'informacion-sesion': 'Session Information',
    'usuario-actual': 'Current User',
    'fecha-inicio-sesion': 'Last Activity',
    'configuraciones-seguridad': 'Security Settings',
    'autenticacion-dos-factores': 'Two-Factor Authentication',
    'no-disponible': 'Not Available',
    'sesiones-activas': 'Active Sessions',
    'tiempo-inactividad': 'Inactivity Timeout',
    'minutos': 'minutes',
    'recomendaciones-seguridad': 'Security Recommendations',
    'cambiar-contraseña-regularmente': 'Change your password regularly',
    'no-compartir-credenciales': 'Do not share your credentials with anyone',
    'cerrar-sesion-dispositivos-compartidos': 'Log out on shared devices',
    'usar-contraseñas-fuertes': 'Use strong and unique passwords',
    // Tabla de Seguridad
    'aspecto': 'Aspect',
    'conexion': 'Connection',
    'estado-sesion': 'Session Status',
    'informacion': 'Information',
    // Usuarios
    'usuarios': 'Users',
    'gestionar-usuarios': 'Manage system users',
    'añadir-usuario': 'Add user',
    'buscar-usuarios': 'Search users...',
    'todos-los-roles': 'All roles',
    'rol-admin': 'Administrator',
    'rol-doctor': 'Doctor',
    'rol-recepcionista': 'Receptionist',
    'rol-contador': 'Accountant',
    'rol-usuario': 'User',
    'cargando-usuarios': 'Loading users',
    'no-se-encontraron-usuarios': 'No users found',
    'editar-usuario': 'Edit user',
    'nuevo-usuario': 'New user',
    'detalles-usuario': 'User details',
    'usuario-creado-exitosamente': 'User created successfully',
    'error-crear-usuario': 'Error creating user',
    'usuario-actualizado-exitosamente': 'User updated successfully',
    'error-actualizar-usuario': 'Error updating user',
    'usuario-eliminado': 'User deleted successfully',
    'error-eliminar-usuario': 'Error deleting user',
    'confirmar-eliminar-usuario': 'Are you sure you want to delete user',
    'foto-perfil': 'Profile Photo',
    'subir-imagen': 'Upload image',
    'email-requerido': 'Email is required',
    'contraseña-minimo-8': 'Password must be at least 8 characters',
    'dejar-vacio-para-no-cambiar': 'Leave empty to not change',
    'nueva-contraseña': 'New password',
    'ingresa-nombre': 'Enter name',
    'ingresa-apellidos': 'Enter last name',
    'predeterminada-dashboard': 'Default (Dashboard)',
    'usuario-activo': 'Active user',
    'archivo-debe-ser-imagen': 'File must be an image',
    'imagen-debe-ser-menor-2mb': 'Image must be less than 2MB',
    'imagen-cargada-correctamente': 'Image uploaded successfully',
    'error-cargar-imagen': 'Error loading image',
    'error-procesar-imagen': 'Error processing image',
    'imagen-eliminada': 'Image deleted',
    'ingresa-email': 'Enter email',
    'a': 'to',
  },
  ca: {
    // Navegació
    dashboard: 'Taulell',
    pacientes: 'Pacients',
    atenciones: 'Atencions',
    tratamientos: 'Tractaments',
    gastos: 'Despeses',
    reportes: 'Informes',
    calendario: 'Calendari',
    configuracion: 'Configuració',
    
    // Dashboard
    'total-pacientes': 'Total pacients',
    'total-atenciones': 'Total atencions',
    'ingresos-mes': 'Ingressos del mes',
    'gastos-mes': 'Despeses del mes',
    'acciones-rapidas': 'Accions ràpides',
    'registrar-consulta': 'Registrar consulta',
    'añadir-cliente': 'Afegir client',
    'nueva-atencion': 'Nova atenció',
    'nuevo-paciente': 'Nou pacient',
    'resumen-financiero': 'Resum financer del mes',
    'ingresos-totales': 'Ingressos totals',
    'gastos-totales': 'Despeses totals',
    'beneficio-neto': 'Benefici net',
    'ingresos-por-mes': 'Ingressos per mes',
    'atenciones-recientes': 'Atencions recents',
    'pacientes-saldo-pendiente': 'Pacients amb saldo pendent',
    'requieren-atencion': 'Requereixen atenció',
    'no-hay-datos': 'No hi ha dades disponibles',
    
    // Configuració
    'configuracion-titulo': 'Configuració',
    'configuracion-descripcion': 'Gestiona el teu perfil i preferències del sistema',
    'perfil': 'Perfil',
    'seguridad': 'Seguretat',
    'notificaciones': 'Notificacions',
    'sistema': 'Sistema',
    'datos': 'Gestió de Dades',
    'informacion-perfil': 'Informació del Perfil',
    'actualiza-informacion': 'Actualitza la teva informació personal',
    'configuracion-seguridad': 'Configuració de Seguretat',
    'gestiona-password': 'Gestiona la teva contrasenya i configuracions de seguretat',
    'configuracion-notificaciones': 'Configuració de Notificacions',
    'personaliza-notificaciones': 'Personalitza com i quan rebre notificacions',
    'configuracion-sistema': 'Configuració del Sistema',
    'personaliza-sistema': 'Personalitza l\'aparença i comportament del sistema',
    
    // Common
    guardar: 'Desar',
    cancelar: 'Cancel·lar',
    buscar: 'Cercar',
    editar: 'Editar',
    eliminar: 'Eliminar',
    'cerrar-sesion': 'Tancar sessió',
    'iniciar-sesion': 'Iniciar sessió',
    
    // Formularis
    nombre: 'Nom',
    apellidos: 'Cognoms',
    email: 'Correu electrònic',
    telefono: 'Telèfon',
    direccion: 'Adreça',
    
    // Sistema
    tema: 'Tema',
    idioma: 'Idioma',
    'zona-horaria': 'Zona Horària',
    'formato-fecha': 'Format de Data',
    moneda: 'Moneda',
    claro: 'Clar',
    oscuro: 'Fosc',
    automatico: 'Automàtic',
    español: 'Castellà',
    ingles: 'Anglès',
    catalan: 'Català',
    'buscar-zona-horaria': 'Cercar zona horària...',
    'zonas-encontradas': 'zona(es) horària(es) trobada(es)',
    'no-encontradas': 'No s\'han trobat zones horàries',
    'idioma-region': 'Idioma i Regió',
    apariencia: 'Aparença',
    'informacion-personal': 'Informació personal',
    'contraseñas-acceso': 'Contrasenyes i accés',
    'alertas-comunicaciones': 'Alertes i comunicacions',
    'preferencias-generales': 'Preferències generals',
    'respaldos-exportacion': 'Còpies de seguretat i exportació',
    'guardando': 'Desant...',
    'guardar-configuracion': 'Desar Configuració',
    
    // Login
    'kenzen-title': 'Kenzen 503',
    'sistema-gestion': 'Sistema de gestió d\'atencions',
    'nombre-usuario': 'Nom d\'usuari',
    'ingresa-usuario': 'Introdueix el teu nom d\'usuari',
    'usuario-requerido': 'El nom d\'usuari és obligatori',
    'contraseña': 'Contrasenya',
    'ingresa-contraseña': 'Introdueix la teva contrasenya',
    'contraseña-requerida': 'La contrasenya és obligatòria',
    'iniciando-sesion': 'Iniciar sessió',
    'derechos-reservados': '© 2024 Tatiana Aldaz, Kenzen Facturació. Tots els drets reservats.',
    'sistema-medica': 'Sistema de gestió mèdica',
    
    // Dashboard
    'atenciones-hoy': 'Atencions avui',
    'ingresos-hoy': 'Ingressos avui',
    'gastos-hoy': 'Despeses avui',
    'tratamientos-activos': 'Tractaments actius',
    'pacientes-nuevos-hoy': 'Pacients nous avui',
    'nuevos-este-mes': 'nous aquest mes',
    'citas-dia': 'Cites del dia',
    'gestionar-servicios': 'Gestionar serveis',
    'registrar-gastos': 'Registrar despeses',
    'todas-atenciones': 'Totes les atencions no anul·lades',
    'sin-datos-ingresos': 'No hi ha dades d\'ingressos',
    'ingresos-apareceran': 'Els ingressos apareixeran quan hi hagi atencions registrades',
    'sin-atenciones-recientes': 'No hi ha atencions recents',
    'atenciones-apareceran': 'Les atencions apareixeran aquí quan es registrin',
    'pendiente': 'Pendent',
    
    // Pacientes
    'buscar-pacientes': 'Cercar pacients...',
    'nuevo-paciente-btn': 'Nou Pacient',
    'filtros': 'Filtres',
    'todos': 'Tots',
    'con-saldo': 'Amb saldo',
    'sin-saldo': 'Sense saldo',
    'exportar': 'Exportar',
    'mostrando': 'Mostrant',
    'de': 'de',
    'resultados': 'resultats',
    'sin-resultados': 'No s\'han trobat pacients',
    'filtrar-por': 'Filtrar per',
    'documento': 'Document',
    'telefono': 'Telèfon',
    'email': 'Correu',
    'ver': 'Veure',
    'eliminar': 'Eliminar',
    'saldo': 'Saldo',
    'acciones': 'Accions',
    
    // Header
    'buscar-placeholder': 'Cercar pacients, atencions, despeses, tractaments...',
    'notificaciones': 'Notificacions',
    'sin-notificaciones': 'No hi ha notificacions',
    'botox': 'Botox',
    'temperatura': 'temperatura',
    'opciones-adicionales': 'Opcions Adicionals',
    'mostrar-temperatura-botox': 'Mostrar temperatura de Botox',
    'mostrar-temperatura-botox-descripcion': 'Mostra la temperatura del refrigerador de Botox al header',
    
    // Pacientes - adicionales
    'añadir-paciente': 'Afegir pacient',
    'tipo-documento': 'Tipus de document',
    'paciente-documento-telefono': 'Pacient, document, telèfon, correu, sector...',
    'cedula': 'Cèdula',
    'pasaporte': 'Passaport',
    'dni': 'DNI',
    'ruc': 'RUC',
    'otros': 'Altres',
    'fecha-registro': 'Data de registre',
    'ultima-actualizacion': 'Última actualització',
    'confirmar-eliminar': 'Estàs segur que vols eliminar aquest pacient?',
    'eliminar-paciente': 'Eliminar pacient',
    'paciente-eliminado': 'Pacient eliminat correctament',
    'error-eliminar': 'Error en eliminar el pacient',
    
    // Atencions
    'nueva-atencion-btn': 'Nova Atenció',
    'fecha-desde': 'Data des de',
    'fecha-hasta': 'Data fins a',
    'fecha-hora': 'Data i Hora',
    'paciente': 'Pacient',
    'tratamiento': 'Tractament',
    'total': 'Total',
    'estado-pago': 'Estat Pagament',
    'pagado': 'Pagat',
    'no-pagado': 'No Pagat',
    'control-toxina': 'Control toxina botulínica',
    'cortesia': 'Cortesia',
    'desconocido': 'Desconegut',
    'estado-actual': 'Estat actual',
    'cambiar-estado': 'Canviar estat',
    'mes-anterior': 'Mes anterior',
    'mes-siguiente': 'Mes següent',
    'dia-anterior': 'Dia anterior',
    'dia-siguiente': 'Dia següent',
    'detalles-atencion': 'Detalls de l\'Atenció',
    'no-especificado': 'No especificat',
    'sin-atenciones': 'No s\'han trobat atencions',
    
    // Tractaments
    'nuevo-tratamiento': 'Nou Tractament',
    'buscar-tratamientos': 'Cercar tractaments...',
    'mostrar-inactivos': 'Mostrar inactius',
    'codigo': 'Codi',
    'nombre': 'Nom',
    'valor': 'Valor',
    'activo': 'Actiu',
    'inactivo': 'Inactiu',
    'estado-actualizado': 'Estat del tractament actualitzat',
    'error-actualizar': 'Error en actualitzar tractament',
    'tratamiento-eliminado': 'Tractament eliminat correctament',
    'error-eliminar-tratamiento': 'Error en eliminar tractament',
    'confirmar-eliminar-tratamiento': 'Estàs segur que vols eliminar aquest tractament?',
    'eliminar-tratamiento': 'Eliminar tractament',
    
    // Despeses
    'nuevo-gasto': 'Nova Despesa',
    'fecha-gasto': 'Data de Despesa',
    'descripcion': 'Descripció',
    'monto': 'Import',
    'tipo-gasto': 'Tipus de Despesa',
    'estado-gasto': 'Estat de la Despesa',
    'cancelado': 'Cancel·lat',
    'no-hay-gastos': 'No s\'han trobat despeses',
    'totales-gastos': 'Totals de Despeses',
    'confirmar-eliminar-gasto': 'Estàs segur que vols eliminar aquesta despesa?',
    'gasto-eliminado': 'Despesa eliminada correctament',
    'error-eliminar-gasto': 'Error en eliminar despesa',
    
    // Calendari
    'nueva-cita': 'Nova Cita',
    'sin-citas': 'No hi ha cites programades',
    'lunes': 'Dilluns',
    'martes': 'Dimarts',
    'miercoles': 'Dimecres',
    'jueves': 'Dijous',
    'viernes': 'Divendres',
    'sabado': 'Dissabte',
    'domingo': 'Diumenge',
    
    // Informes
    'reportes': 'Informes',
    'reporte-completo': 'Informe Complet',
    'reporte-ventas': 'Informe de Vendes',
    'ingresos-por-mes-grafico': 'Ingressos per Mes',
    'formas-pago': 'Formes de Pagament',
    'tratamientos-mas-usados': 'Tractaments Més Utilitzats',
    'tarjeta-credito': 'Targeta de crèdit',
    'tarjeta-debito': 'Targeta de dèbit',
    'efectivo': 'Efectiu',
    'transferencia': 'Transferència',
    'no-hay-datos-reporte': 'No hi ha dades per mostrar en aquest període',
    'hoy': 'Avui',
    'todos': 'Tots',
    'activas': 'Actives',
    'anuladas': 'Anul·lades',
    'semana': 'Setmana',
    'dia': 'Dia',
    'editar': 'Editar',
    'reporte-financiero': 'Informe financer',
    'reporte-operativo': 'Informe operatiu',
    'comparativo-anual': 'Comparatiu anual',
    'analisis-tendencias': 'Anàlisi de tendències',
    'analisis-rentabilidad': 'Anàlisi de rendibilitat',
    'hora': 'Hora',
    'generar': 'Generar',
    'desde': 'Des de',
    'hasta': 'Fins a',
    'tipo-reporte': 'Tipus d\'Informe',
    'año-anterior': 'Any anterior',
    'año-siguiente': 'Any següent',
    'año-actual': 'Any Actual',
    'ingresos-totales': 'Ingressos totals',
    'total-atenciones': 'Total atencions',
    'promedio-atencion': 'Promedi per atenció',
    'ingresos-periodo': 'Ingressos del període',
    'gastos-periodo': 'Despeses del període',
    'cantidad-gastos-periodo': 'Quantitat de despeses',
    'promedio-gasto-periodo': 'Mitjana per despesa',
    'pacientes-nuevos-periodo': 'Pacients nous en el període',
    'pacientes-mes-en-periodo': 'Nous aquest mes (en període)',
    'pacientes-hoy-en-periodo': 'Nous avui (en període)',
    'tratamientos-distintos-periodo': 'Tractaments distints',
    'total-usos-tratamientos': 'Total d\'aplicacions',
    'tratamientos-inactivos': 'Tractaments inactius',
    'resumen-financiero-periodo': 'Resum financer del període',
    'margen-beneficio': 'Marge de benefici',
    'atenciones-no-cobradas': 'Atencions no cobrades',
    'pendiente-cobro': 'pendent de cobrament',
    'descuentos-aplicados': 'Descomptes aplicats',
    'atenciones-cortesia': 'Atencions de cortesia',
    'ingresos-vs-gastos': 'Ingressos vs despeses per mes',
    'del-periodo': 'Del període',
    'estado-cobro-atenciones': 'Estat de cobrament d\'atencions',
    'atenciones-por-dia-semana': 'Atencions per dia de la setmana',
    'atenciones-por-mes': 'Atencions per mes',
    'pacientes-por-sector': 'Pacients per sector',
    'sin-datos-ingresos': 'No hi ha dades d\'ingressos',
    'sin-datos-atenciones': 'No hi ha dades d\'atencions',
    'sin-datos-financieros': 'No hi ha dades financeres en el període',
    'sin-datos-formas-pago': 'No hi ha dades de formes de pagament',
    'sin-datos-estado-pago': 'No hi ha dades d\'estat de cobrament',
    'top-pacientes-periodo': 'Pacients més freqüents del període',
    'visitas': 'Visites',
    'total-facturado': 'Total facturat',
    'atenciones-pendientes-cobro': 'Atencions pendents de cobrament',
    'sin-atenciones-pendientes': 'No hi ha atencions pendents de cobrament',
    'pacientes-saldo-pendiente': 'Pacients amb saldo pendent',
    'saldo-pendiente': 'Saldo pendent',
    'sin-saldos-pendientes': 'No hi ha pacients amb saldo pendent',
    'sin-datos-pacientes': 'No hi ha dades de pacients en el període',
    'transacciones': 'Transaccions',
    'paciente': 'Pacient',
    'ingresos': 'Ingressos',
    'atenciones-realizadas': 'Atencions realitzades',
    'ticket-promedio': 'Ticket promig',
    'total-gastos': 'Total despeses',
    'gastos-mes': 'Despeses del mes',
    'gastos-hoy': 'Despeses d\'avui',
    'gastos-categoria': 'Despeses per Categoria',
    'ingresos-por-mes': 'Ingressos per Mes',
    
    // Encapçalats de taules
    'nro-documento': 'Núm. Document',
    'tipo-documento-tabla': 'Tipus de document',
    'nombre-paciente': 'Nom del pacient',
    'nro-identificacion': 'Núm. identificació',
    'nombre-factura': 'Nom factura',
    'fecha-hora-tabla': 'Data i Hora',
    'hora-tabla': 'Hora',
    'valor-tabla': 'Valor',
    'detalles-tabla': 'Detalls',
    'forma-pago': 'Forma de pagament',
    'todas': 'Totes',
    'cheque': 'Xec',
    'saldo-favor': 'Saldo a Favor',
    'otro-financiero': 'Altres Amb Utilització Del Sistema Financer',
    'filas-pagina': 'Files per pàgina',
    'ultimos-meses': 'Últims 12 mesos',
    'distribucion-actual': 'Distribució actual',
    'exportar-reporte': 'Exportar informe',
    'exportar-pdf-completo': 'Exportar PDF complet',
    'exportar-excel': 'Exportar Excel',
    'imprimir-reporte': 'Imprimir informe',
    'vista-previa': 'Vista prèvia',
    'ver-detalles': 'Veure detalls',
    'cambiar-estado-pago': 'Canviar Estat del Pagament',
    'nuevo-estado-pago': 'Nou estat de pagament',
    'atencion-pagada': 'L\'atenció ha estat pagada',
    'atencion-no-pagada': 'L\'atenció no ha estat pagada',
    'pago-pendiente-confirmacion': 'Pagament pendent de confirmació',
    'atencion-cortesia': 'Atenció de cortesia (sense cost)',
    'esta-accion-no-se-puede-deshacer': 'Aquesta acció no es pot desfer',
    'sector': 'Sector',
    'nro-factura': 'Núm. factura',
    'detalle': 'Detall',
    'descuento': 'Descompte',
    'observaciones': 'Observacions',
    'precio': 'Preu',
    'estado': 'Estat',
    'fecha': 'Data',
    'concepto': 'Concepte',
    'categoria': 'Categoria',
    'subcategoria': 'Subcategoria',
    'tipo': 'Tipus',
    'cargando': 'Carregant...',
    'cargando-atenciones': 'Carregant atencions...',
    'cargando-pacientes': 'Carregant pacients...',
    'cargando-tratamientos': 'Carregant tractaments...',
    'resetear-año-actual': 'Restablir a l\'any actual',
    'filtros-reporte': 'Filtres d\'informe',
    'configuracion': 'Configuració',
    'confirmar-eliminar': 'Confirmar Eliminació',
    'eliminar': 'Eliminar',
    'atenciones-del': 'Atencions del',
    'sin-fecha-seleccionada': 'Sense data seleccionada',
    'editar-paciente': 'Editar pacient',
    'nuevo-paciente': 'Nou pacient',
    'detalles-paciente': 'Detalls del pacient',
    'informacion-personal': 'Informació personal',
    'datos-facturacion': 'Dades de facturació',
    'informacion-sistema': 'Informació del sistema',
    'nombre-completo': 'Nom complet',
    'direccion': 'Direcció',
    'no-especificado': 'No especificat',
    'no-especificada': 'No especificada',
    'cargando-datos-facturacion': 'Carregant dades de facturació...',
    'no-hay-datos-facturacion': 'No hi ha dades de facturació',
    'paciente-sin-perfiles-facturacion': 'Aquest pacient no té perfils de facturació registrats',
    'principal': 'Principal',
    'registrado-el': 'Registrat el',
    'cargando-saldos': 'Carregant saldos...',
    'sin-movimientos-saldo': 'Sense moviments de saldo',
    'paciente-sin-movimientos-saldo': 'Aquest pacient no té moviments de saldo registrats',
    'resumen-saldo': 'Resum de Saldo',
    'saldo-total': 'Saldo Total',
    'movimientos-saldo': 'Moviments de Saldo',
    'movimientos-saldo-cargaran': 'Els moviments de saldo es carregaran quan sigui necessari',
    'id-paciente': 'ID del Pacient',
    'fecha-registro': 'Data de Registre',
    'ultima-actualizacion': 'Última Actualització',
    'eliminando': 'Eliminant...',
    'no-puede-eliminarse-a-si-mismo': 'No et pots eliminar a tu mateix',
    'cerrar': 'Tancar',
    'confirmar-eliminar-paciente': 'Estàs segur que vols eliminar aquest pacient?',
    'informacion-paciente': 'Informació del pacient',
    'importante': 'Important',
    'no-se-puede-eliminar-paciente-atenciones': 'No es podrà eliminar el pacient si té atencions registrades. En aquest cas, es mostrarà un missatge d\'error.',
    'cancelar': 'Cancel·lar',
    'eliminando': 'Eliminant...',
    'estado-saldo': 'Estat del saldo',
    'sin-email': 'Sense correu',
    'añadir-paciente': 'Afegir pacient',
    'buscar': 'Cercar',
    'paciente-documento-telefono': 'Cercar per pacient, document, telèfon...',
    'tipo-documento': 'Tipus de document',
    'cedula': 'Cèdula',
    'pasaporte': 'Passaport',
    'dni': 'DNI',
    'ruc': 'RUC',
    'otros': 'Altres',
    'a-favor': 'A favor',
    'a-deber': 'A deure',
    'sin-sector': 'Sense sector',
    'busqueda-activa': 'Cerca activa',
    'mostrando-todos-resultados': 'Mostrant tots els resultats per',
    'total-registrados': 'Total registrats',
    'registros': 'registres',
    'error': 'Error',
    'año': 'Any',
    'este-mes-de': 'Aquest mes de',
    'sin-telefono': 'Sense telèfon',
    'este-año': 'aquest any',
    'este-mes': 'aquest mes',
    'limpiar-busqueda': 'Netejar cerca',
    'editar-atencion': 'Editar atenció',
    'nueva-atencion-btn': 'Nova atenció',
    'fecha-requerida': 'La data és obligatòria',
    'debe-seleccionar-paciente': 'Has de seleccionar un pacient',
    'nombre-minimo-caracteres': 'El nom ha de tenir almenys 2 caràcters',
    'numero-identificacion-requerido': 'El número d\'identificació és obligatori',
    'email-invalido': 'Correu electrònic invàlid',
    'tratamiento-requerido': 'El tractament és obligatori',
    'valor-mayor-cero': 'El valor ha de ser major a 0',
    'descuento-no-negativo': 'El descompte no pot ser negatiu',
    'valor-total-mayor-cero': 'El valor total ha de ser major a 0',
    'motivo-anulacion-obligatorio': 'El motiu d\'anul·lació és obligatori quan s\'anul·la l\'atenció',
    'atencion-creada-correctamente': 'Atenció creada correctament',
    'atencion-actualizada-correctamente': 'Atenció actualitzada correctament',
    'error-crear-atencion': 'Error en crear l\'atenció',
    'error-actualizar-atencion': 'Error en actualitzar l\'atenció',
    'buscar-por-nombre-documento': 'Cercar per nom o document...',
    'seleccionado': 'Seleccionat',
    'ningun-paciente-seleccionado': 'Cap pacient seleccionat',
    'saldo-paciente': 'Saldo del pacient',
    'paciente-saldo-favor-utilizar': 'El pacient té saldo a favor que pot ser utilitzat',
    'paciente-saldo-pendiente-pago': 'El pacient té saldo pendent de pagament',
    'paciente-no-saldo-pendiente': 'El pacient no té saldo pendent',
    'paciente-no-movimientos-saldo': 'El pacient no té moviments de saldo registrats',
    'informacion-facturacion': 'Informació de Facturació',
    'numero-factura': 'Número de factura',
    'seleccionar-forma-pago': 'Seleccionar forma de pagament',
    'detalles-adicionales-pago': 'Detalls addicionals del pagament',
    'usar-otros-datos-facturacion': 'Utilitzar altres dades de facturació',
    'agregar-datos': 'Afegir dades',
    'no-hay-datos-facturacion-disponibles': 'No hi ha dades de facturació disponibles. Pots afegir noves dades.',
    'observaciones-adicionales': 'Observacions addicionals',
    'anular-atencion': 'Anul·lar atenció',
    'motivo': 'Motiu',
    'describe-motivo-anulacion': 'Descriu el motiu de l\'anul·lació...',
    'actualizar': 'Actualitzar',
    'agregar-datos-facturacion': 'Afegir Dades de Facturació',
    'nombre-requerido': 'El nom és obligatori',
    'numero-documento-requerido': 'El número de document és obligatori',
    'datos-facturacion-creados': 'Dades de facturació creades correctament',
    'error-crear-datos-facturacion': 'Error en crear les dades de facturació',
    'datos-facturacion-actualizados': 'Dades de facturació actualitzades correctament',
    'error-actualizar-datos-facturacion': 'Error en actualitzar les dades de facturació',
    'datos-facturacion-eliminados': 'Dades de facturació eliminades correctament',
    'error-eliminar-datos-facturacion': 'Error en eliminar les dades de facturació',
    'movimiento-saldo-creado': 'Moviment de saldo creat correctament',
    'error-crear-movimiento-saldo': 'Error en crear el moviment de saldo',
    'paciente-actualizado-correctamente': 'Pacient actualitzat correctament',
    'paciente-creado-correctamente': 'Pacient creat correctament',
    'error-guardar-paciente': 'Error en guardar el pacient',
    'ingrese-nombre-completo': 'Introdueix el nom complet',
    'ingrese-numero-documento': 'Introdueix el número de document',
    'ingrese-direccion': 'Introdueix la direcció',
    'ingrese-sector': 'Introdueix el sector',
    'ingrese-email': 'Introdueix el correu electrònic',
    'marcar-opcion-datos-facturacion': 'Marca aquesta opció si vols afegir dades de facturació diferents a les dades personals',
    'crear-paciente': 'Crear Pacient',
    'añadir-paciente': 'Añadir paciente',
    'añadir-movimiento': 'Afegir moviment',
    'editar-datos-facturacion': 'Editar dades de facturació',
    'añadir-datos-facturacion-modal': 'Afegir dades de facturació',
    'confirmar-eliminar-datos-facturacion': 'Estàs segur que vols eliminar aquestes dades de facturació?',
    'informacion-datos': 'Informació de les dades',
    'eliminar-datos': 'Eliminar Dades',
    'editar-movimiento-saldo': 'Editar moviment de saldo',
    'añadir-movimiento-saldo': 'Afegir moviment de saldo',
    'saldos': 'Saldos',
    'añadir-datos-facturacion': 'Afegir dades de facturació',
    // Gastos - Nuevas traducciones
    'añadir-gasto': 'Afegir despesa',
    'total-general': 'Total General',
    'rango-seleccionado': 'Rang Seleccionat',
    'selecciona-fechas': 'Selecciona dates',
    'buscar-gastos-placeholder': 'Descripció, proveïdor, factura...',
    'todas-las-categorias': 'Totes les categories',
    'suministros': 'Subministraments',
    'equipos': 'Equipaments',
    'servicios': 'Serveis',
    'personal': 'Personal',
    'mantenimiento': 'Manteniment',
    'todos-los-tipos': 'Tots els tipus',
    'fijo': 'Fix',
    'variable': 'Variable',
    'ocasional': 'Ocasional',
    'todos-los-estados': 'Tots els estats',
    'vencido': 'Vencut',
    'fecha-desde-no-puede-ser-superior': 'La data "Des de" no pot ser superior a "Fins a"',
    'estado-gasto-actualizado': 'Estat de despesa actualitzat correctament',
    'error-actualizar-estado-gasto': 'Error en actualitzar l\'estat de la despesa',
    'error-cargar-gastos': 'Error en carregar les despeses',
    'anterior': 'Anterior',
    'siguiente': 'Següent',
    'detalles-gasto': 'Detalls de la despesa',
    'gasto-anulado': 'Despesa Anul·lada',
    'anulado': 'Anul·lat',
    'motivo-anulacion': 'Motiu d\'Anul·lació',
    'nuevo-estado-gasto': 'Nou estat de despesa',
    'gasto-ha-sido-pagado': 'La despesa ha estat pagada',
    'gasto-ha-sido-cancelado': 'La despesa ha estat cancel·lada',
    'informacion-basica': 'Informació Bàsica',
    'tipo-gasto': 'Tipus de Despesa',
    'informacion-financiera': 'Informació Financera',
    'informacion-proveedor': 'Informació del Proveïdor',
    'numero-recibo': 'Número de Rebut',
    'fechas': 'Dates',
    'fecha-gasto': 'Data de la Despesa',
    'fecha-vencimiento': 'Data de Venciment',
    'informacion-adicional': 'Informació Adicional',
    'archivos-adjuntos': 'Arxius Adjunts',
    // GastoForm - Validaciones y mensajes
    'concepto-minimo-caracteres': 'El concepte ha de tenir almenys 2 caràcters',
    'descripcion-minimo-caracteres': 'La descripció ha de tenir almenys 2 caràcters',
    'categoria-obligatoria': 'La categoria és obligatòria',
    'fecha-gasto-obligatoria': 'La data de la despesa és obligatòria',
    'gasto-creado-correctamente': 'Despesa creada correctament',
    'gasto-actualizado-correctamente': 'Despesa actualitzada correctament',
    'error-crear-gasto': 'Error en crear la despesa',
    'error-actualizar-gasto': 'Error en actualitzar la despesa',
    'id-gasto-no-disponible': 'ID de despesa no disponible per actualització',
    'concepto-gasto': 'Concepte de la despesa',
    'descripcion-gasto': 'Descripció de la despesa',
    'seleccionar-categoria': 'Seleccionar categoria',
    'seleccionar-subcategoria': 'Seleccionar subcategoria',
    'moneda': 'Moneda',
    'dolar-americano': 'Dòlar Americà',
    'euro': 'Euro',
    'sol-peruano': 'Sol Peruà',
    'peso-colombiano': 'Pes Colombià',
    'peso-mexicano': 'Pes Mexicà',
    'seleccionar-forma-pago': 'Seleccionar forma de pagament',
    'nombre-proveedor': 'Nom del proveïdor',
    'numero-factura': 'Número de factura',
    'numero-recibo-placeholder': 'Número de rebut',
    'observaciones-adicionales': 'Observacions addicionals...',
    'ruta-archivo-adjunto': 'Ruta de l\'arxiu adjunt',
    // Subcategorías
    'medicamentos': 'Medicaments',
    'material-quirurgico': 'Material quirúrgic',
    'material-oficina': 'Material d\'oficina',
    'productos-limpieza': 'Productes de neteja',
    'equipos-medicos': 'Equipaments mèdics',
    'equipos-oficina': 'Equipaments d\'oficina',
    'mobiliario': 'Mobiliari',
    'tecnologia': 'Tecnologia',
    'servicios-medicos': 'Serveis mèdics',
    'servicios-limpieza': 'Serveis de neteja',
    'servicios-mantenimiento': 'Serveis de manteniment',
    'servicios-consultoria': 'Serveis de consultoria',
    'salarios': 'Salaris',
    'beneficios': 'Beneficis',
    'capacitacion': 'Capacitació',
    'seguros': 'Assegurances',
    'mantenimiento-preventivo': 'Manteniment preventiu',
    'reparaciones': 'Reparacions',
    'servicios-tecnicos': 'Serveis tècnics',
    'gastos-varios': 'Despeses diverses',
    'impuestos': 'Impostos',
    // Tratamientos - Nuevas traducciones
    'añadir-tratamiento': 'Afegir tractament',
    'error-cargar-tratamientos': 'Error en carregar tractaments',
    'no-se-pudieron-cargar-tratamientos': 'No s\'han pogut carregar els tractaments. Si us plau, intenta-ho de nou.',
    'buscar-tratamientos-placeholder': 'Nom, codi...',
    'no-se-encontraron-tratamientos': 'No s\'han trobat tractaments',
    'sin-codigo': 'Sense codi',
    'sin-detalles': 'Sense detalls',
    'desactivar': 'Desactivar',
    'activar': 'Activar',
    'editar-tratamiento': 'Editar tractament',
    'informacion-tratamiento': 'Informació del tractament',
    'asegurate-tratamiento-no-utilizado': 'Assegura\'t que aquest tractament no estigui sent utilitzat en atencions abans d\'eliminar-lo.',
    'nombre-tratamiento-requerido': 'El nom del tractament és obligatori',
    'valor-requerido': 'El valor és obligatori',
    'tratamiento-actualizado-exitosamente': 'Tractament actualitzat exitosament',
    'tratamiento-creado-exitosamente': 'Tractament creat exitosament',
    'error-guardar-tratamiento': 'Error en guardar tractament',
    'codigo-interno': 'Codi intern',
    'nombre-tratamiento-placeholder': 'Nom del tractament *',
    'añadir': 'Afegir',
    // DatosFacturacionTable
    'gestiona-perfiles-facturacion': 'Gestiona els perfils de facturació del pacient',
    'marcar-como-principal': 'Marcar com a principal',
    'contacto': 'Contacte',
    // Seguridad del Sistema
    'seguridad-sistema': 'Seguretat del sistema',
    'seguridad-del-sistema': 'Seguretat del sistema',
    'configuracion-seguridad-sistema': 'Configuració de seguretat i protecció del sistema',
    'sesion-activa': 'Sessió Activa',
    'sesion-segura-encriptada': 'La teva sessió està segura i encriptada',
    'ver-detalles-seguridad': 'Veure Detalls de Seguretat',
    'configuracion-seguridad-actualizada': 'La configuració de seguretat s\'actualitza automàticament',
    // Respaldos
    'respaldos-automaticos': 'Còpies de Seguretat Automàtiques',
    'crear-respaldos-automaticos': 'Crear còpies de seguretat automàtiques de les dades',
    'frecuencia': 'Freqüència',
    'diario': 'Diari',
    'semanal': 'Setmanal',
    'mensual': 'Mensual',
    'respaldos': 'Còpies de Seguretat',
    // Detalles de Seguridad
    'detalles-seguridad': 'Detalls de Seguretat',
    'estado-conexion': 'Estat de la Connexió',
    'protocolo-seguro': 'Protocol Segur',
    'certificado-ssl': 'Certificat SSL',
    'valido': 'Vàlid',
    'encriptacion': 'Encriptació',
    'informacion-sesion': 'Informació de Sessió',
    'usuario-actual': 'Usuari Actual',
    'fecha-inicio-sesion': 'Última Activitat',
    'configuraciones-seguridad': 'Configuracions de Seguretat',
    'autenticacion-dos-factores': 'Autenticació de Dos Factors',
    'no-disponible': 'No Disponible',
    'sesiones-activas': 'Sessions Actives',
    'tiempo-inactividad': 'Temps d\'Inactivitat',
    'minutos': 'minuts',
    'recomendaciones-seguridad': 'Recomanacions de Seguretat',
    'cambiar-contraseña-regularmente': 'Canvia la teva contrasenya regularment',
    'no-compartir-credenciales': 'No comparteixis les teves credencials amb ningú',
    'cerrar-sesion-dispositivos-compartidos': 'Tanca sessió en dispositius compartits',
    'usar-contraseñas-fuertes': 'Utilitza contrasenyes fortes i úniques',
    'rol': 'Rol',
    // Tabla de Seguridad
    'aspecto': 'Aspecte',
    'conexion': 'Connexió',
    'estado-sesion': 'Estat de Sessió',
    'informacion': 'Informació',
    // Usuarios
    'usuarios': 'Usuaris',
    'gestionar-usuarios': 'Gestiona els usuaris del sistema',
    'añadir-usuario': 'Afegir usuari',
    'buscar-usuarios': 'Buscar usuaris...',
    'todos-los-roles': 'Tots els rols',
    'rol-admin': 'Administrador',
    'rol-doctor': 'Doctor',
    'rol-recepcionista': 'Recepcionista',
    'rol-contador': 'Comptable',
    'rol-usuario': 'Usuari',
    'cargando-usuarios': 'Carregant usuaris',
    'no-se-encontraron-usuarios': 'No s\'han trobat usuaris',
    'editar-usuario': 'Editar usuari',
    'nuevo-usuario': 'Nou usuari',
    'detalles-usuario': 'Detalls de l\'usuari',
    'usuario-creado-exitosamente': 'Usuari creat exitosament',
    'error-crear-usuario': 'Error en crear usuari',
    'usuario-actualizado-exitosamente': 'Usuari actualitzat exitosament',
    'error-actualizar-usuario': 'Error en actualitzar usuari',
    'usuario-eliminado': 'Usuari eliminat exitosament',
    'error-eliminar-usuario': 'Error en eliminar usuari',
    'confirmar-eliminar-usuario': 'Estàs segur que vols eliminar l\'usuari',
    'foto-perfil': 'Foto de Perfil',
    'subir-imagen': 'Pujar imatge',
    'email-requerido': 'El correu electrònic és obligatori',
    'contraseña-minimo-8': 'La contrasenya ha de tenir almenys 8 caràcters',
    'dejar-vacio-para-no-cambiar': 'Deixar buit per no canviar',
    'nueva-contraseña': 'Nova contrasenya',
    'ingresa-nombre': 'Introdueix el nom',
    'ingresa-apellidos': 'Introdueix els cognoms',
    'predeterminada-dashboard': 'Predeterminada (Taulell)',
    'usuario-activo': 'Usuari actiu',
    'archivo-debe-ser-imagen': 'El fitxer ha de ser una imatge',
    'imagen-debe-ser-menor-2mb': 'La imatge ha de ser menor a 2MB',
    'imagen-cargada-correctamente': 'Imatge carregada correctament',
    'error-cargar-imagen': 'Error en carregar la imatge',
    'error-procesar-imagen': 'Error en processar la imatge',
    'imagen-eliminada': 'Imatge eliminada',
    'ingresa-email': 'Introdueix el correu electrònic',
    'a': 'a',
  },
}

export const t = (key: string, lang: Language = 'es'): string => {
  const langTranslations = translations[lang] as Record<string, string>
  return langTranslations[key] || key
}

